(() => {
  'use strict';
  const grid = document.getElementById('flatsGrid');
  if (!grid) return;

  // ─── КОМНАТНОСТЬ ИЗ ФРАГМЕНТА `#rooms=N` (25.09.2026, проверка поиска P2-1) ───
  // Ссылка «Все N квартир — в витрине ЖК» со страницы комнатности ведёт на КАНОНИЧНЫЙ
  // адрес витрины с фрагментом: `/…/kvartiry/#rooms=2`. Фрагмент роботы отдельным адресом
  // не считают (прежний `?rooms=2` давал ~525 новых ссылок с параметром). Человеку отбор
  // нужен тот же, что по `?rooms=2`, поэтому ДО чтения состояния ниже переписываем адрес
  // в `?rooms=2`: дальше всё — стартовое состояние, серверная выдача, «Назад», «Сбросить»,
  // ряд страниц, корпус генплана — работает ровно как по ссылке с параметром. Параметр
  // в адресе уже есть — фрагмент не трогаем: явный отбор важнее.
  // 28.09.2026: пришли по такой ссылке — витрина встаёт на выдачу (landOnResults ниже),
  // а не на генплан сверху: человек просил «все квартиры этой комнатности».
  const LAND_ON_RESULTS = /^#(?:rooms=\d|planirovki(?:&.*)?)$/.test(String(location.hash || ''));
  (function roomsFromFragment() {
    const hash = /^#rooms=(\d)$/.exec(location.hash);
    const query = new URLSearchParams(location.search);
    if (!hash || query.has('rooms') || query.has('rooms_min')) return;
    query.set('rooms', hash[1]);
    try {
      history.replaceState({}, '', location.pathname + '?' + query.toString());
    } catch {
      // история недоступна (песочница) — страница откроется без отбора, как голый адрес
    }
  })();

  // SEC-015: escHtml для защиты от XSS
  const esc = window.escHtml || (s => { if (!s && s !== 0) return ''; const d = document.createElement('div'); d.textContent = s; return d.innerHTML; });

  const API = '/flat_api.php';

  // Мин. скидка (%), при которой квартиру показываем «со скидкой». SSOT — PHP:
  // FlatHandler::DISCOUNT_MIN_PCT (app/handlers/FlatHandler.php). JS не может
  // импортить PHP → значения синхронизированы вручную, паритет стережёт
  // инвариант-тест tests/Integration/flat-discount-badge.test.mjs.
  const DISCOUNT_MIN_PCT = 3;

  // ─── STATE ───
  // ⛔ F.2-fix: на ЧПУ-адресе квартир ЖК в query нет `?city=`, и умолчание `krasnodar`
  // подписывало московскую страницу Краснодаром — в микроразметке ItemList и в адресе.
  // Город страницы называет СЕРВЕР, как и дом. Порядок: явный query → сервер → умолчание.
  let currentCity = new URLSearchParams(location.search).get('city')
    || String(window.BRONI_FLATS_CITY || '')
    || 'krasnodar';
  let currentRooms = new URLSearchParams(location.search).get('rooms') || '';
  if (new URLSearchParams(location.search).get('from_slice') === '1'
      && new URLSearchParams(location.search).get('rooms_min') === '4') currentRooms = '4';
  let currentLandingScope = new URLSearchParams(location.search).get('landing_scope') || grid.dataset.landingScope || '';
  // F.1: ЖК страницы. На ЧПУ-адресе /novostroyki/{город}/zhk-{слаг}/kvartiry/ query
  // пуст (nginx стирает его хвостовым `?` — защита от подмены ЖК), поэтому дом
  // называет СЕРВЕР переменной window.BRONI_FLATS_BUILDING_ID. Без этого фолбэка
  // новая страница рисовала бы каталог всего города под адресом одного ЖК.
  const PINNED_BUILDING = String(window.BRONI_FLATS_BUILDING_ID || '');
  // ⛔ 14.08.2026: ГОРОД, НАЗВАННЫЙ ЧПУ-АДРЕСОМ ВИТРИНЫ /novostroyki/{город}/kvartiry/.
  // Непусто ТОЛЬКО там (сервер печатает переменную только на этом адресе) — по нему
  // отличается «город выбран фильтром» от «город объявлен адресом страницы». Без него
  // ломались бы два стыка сразу: syncUrl() увёл бы адрес обратно на flats.php?city=,
  // а applyStickyCityPrefill() подменил бы город из cookie. Оба — F.1-класс: сервер
  // отдаёт верное, клиент через 200 мс возвращает чужое, и Яндекс видит именно второе.
  const PINNED_CITY = String(window.BRONI_FLATS_CITY_PINNED || '');
  // Город, который страница получила от СЕРВЕРА (на ЧПУ ЖК — город из пути). Нужен
  // «Назад» (popstate): после 18.09 на ЧПУ ЖК город в query не пишется, и фолбэк
  // обязан быть тем же, что при загрузке (строка 21), а не краснодарским умолчанием.
  const SERVER_CITY = String(window.BRONI_FLATS_CITY || '');
  // Умолчание сортировки. В адрес НЕ пишется (18.09.2026, yandex-mobile 1.5): оно и
  // так восстанавливается при чтении адреса, а в строке браузера только плодило
  // варианты одной страницы — мобильный робот Яндекса записывал ЧПУ ЖК как
  // «…/kvartiry/?city=…&sort=price_asc».
  const DEFAULT_SORT = 'price_asc';
  // Первая синхронизация адреса (после стартовой загрузки) идёт replaceState:
  // стартовая загрузка — не действие человека, и новая запись в истории делала
  // «Назад» бесполезной (он возвращал на ту же страницу).
  let urlSyncedOnce = false;
  let currentBuilding = new URLSearchParams(location.search).get('building_id') || PINNED_BUILDING;
  let currentSort = new URLSearchParams(location.search).get('sort') || DEFAULT_SORT;
  let currentDiscount = new URLSearchParams(location.search).get('discount') === '1';
  let currentRenovation = new URLSearchParams(location.search).get('renovation') || ''; // 5.2: бакет отделки
  let currentInstallment = new URLSearchParams(location.search).get('installment') === '1'; // 5.3: рассрочка застройщика
  let lastOffers = null; // 8.4: последние счётчики вариантов (см. hideEmptyOffers)
  // ФИДЫ-2.0 бл.2: класс помещения. '' = «Всё» (дефолт), 'flat', 'apartments'.
  // Дефолт «Всё» осознанно: апартаменты — законный товар, прятать их из каталога
  // нельзя; честность обеспечивается маркировкой карточки, а не фильтром.
  let currentKind = new URLSearchParams(location.search).get('kind') || '';
  // jk-smart-filter 1.3: корпуса ЖК («Литер 1|Литер 2») — значение плашки «срок
  // сдачи» inline-фильтра карточки ЖК. Приходит ТОЛЬКО из URL по ссылке
  // «Открыть в полном каталоге →»: своего контрола в каталоге нет. Селект
  // #filterDeadline выбирает ГОД — с блока 8.4 по сроку корпуса квартиры
  // (Deadline::sqlFlatCondition), а корпуса поимённо приходят только отсюда.
  // Без этого состояния переход из фильтра ЖК молча терял выбранный срок.
  let currentSections = new URLSearchParams(location.search).get('sections') || '';
  let currentSectionNumbers = new URLSearchParams(location.search).get('section_numbers') || '';
  let currentPage = Math.max(1, parseInt(new URLSearchParams(location.search).get('page'), 10) || 1);
  let currentView = localStorage.getItem('flats_view') || 'grid'; // ВАЖНО-10: сохранять в localStorage
  let totalFlats = 0;
  let totalPages = 0;
  let isLoading = false;
  let abortCtrl = null;

  // ─── CITY NAMES ───
  // Падежи (косметика витрины, 15.07.2026): SSOT — реестр городов (таблица `cities`,
  // колонки name_gen/name_prep), сервер отдаёт его в window.__FLATS_CITIES__ (flats.php).
  // Карты ниже остаются ТОЛЬКО как fallback на случай, если инлайн не доехал; они
  // покрывают 6 городов, реестр — все visible (в т.ч. omsk/kaluga, где раньше в hero
  // подставлялся латинский slug либо пустая строка).
  //
  // ⚠️ Ловушка, из-за которой и был баг: карта называется `cityNames`, но хранит
  // РОДИТЕЛЬНЫЙ падеж («Москвы»), а не именительный. Её подставили в предложный слот
  // («квартир в ...») → «3 103 квартир в Москвы». Поэтому ниже — явные cityNom/
  // cityGen/cityPrep вместо прямого обращения к картам: падеж виден в имени функции.
  const CITY_REG = (window.__FLATS_CITIES__ && typeof window.__FLATS_CITIES__ === 'object')
    ? window.__FLATS_CITIES__ : {};
  const cityNamesGenFallback = {
    kursk: 'Курска', belgorod: 'Белгорода', voronezh: 'Воронежа',
    krasnodar: 'Краснодара', spb: 'Санкт-Петербурга', moscow: 'Москвы'
  };
  const cityNamesNom = {
    kursk: 'Курск', belgorod: 'Белгород', voronezh: 'Воронеж',
    krasnodar: 'Краснодар', spb: 'Санкт-Петербург', moscow: 'Москва'
  };
  // Именительный «что?» — для подписей кнопок/чипов («Москва»).
  const cityNom  = slug => (CITY_REG[slug] && CITY_REG[slug].name) || cityNamesNom[slug] || slug;
  // Родительный «чего?» — «Квартиры в новостройках Москвы».
  const cityGen  = slug => (CITY_REG[slug] && CITY_REG[slug].gen) || cityNamesGenFallback[slug] || cityNom(slug);
  // Предложный «о чём?» — «квартир в Москве». Нет курируемого склонения → именительный
  // (тоже валидно и читаемо), но НИКОГДА не пустая строка.
  const cityPrep = slug => (CITY_REG[slug] && CITY_REG[slug].prep) || cityNom(slug);

  // ─── DOM ───
  const pagination = document.getElementById('flatsPagination');
  const emptyState = document.getElementById('flatsEmpty');
  const heroSub = document.getElementById('flatsHeroSub');
  const statFlats = document.getElementById('statFlats');
  const statBuildings = document.getElementById('statBuildings');
  const statPriceFrom = document.getElementById('statPriceFrom');
  const flatsCount = document.getElementById('flatsCount');
  const loadMoreWrap = document.getElementById('flatsLoadMore');
  const loadMoreBtn = document.getElementById('flatsMoreBtn');
  // I4: панель сортировки/вида — скрывается в режиме группировки планировок (один ЖК).
  const toolbarSection = document.querySelector('.flats-toolbar-section');

  function syncLandingNotice() {
    const notice = document.getElementById('flatsLandingNotice');
    if (!notice) return;
    const visible = currentLandingScope !== '' && currentLandingScope === grid.dataset.landingScope;
    notice.hidden = !visible;
    notice.parentElement.classList.toggle('flats-cards--landing', visible);
  }

  // ─── MORTGAGE CALC (B1: BuyAbility) ───
  const calcMonthly = window.calcMonthly || ((price, downPct, rate, years) => {
    const p = price * (1 - downPct / 100), mr = rate / 100 / 12, n = years * 12;
    return mr === 0 ? Math.round(p / n) : Math.round(p * (mr * Math.pow(1 + mr, n)) / (Math.pow(1 + mr, n) - 1));
  });

  // B1: BuyAbility color coding (ежемесячный платёж)
  function buyAbilityClass(monthly) {
    if (monthly <= 30000) return 'buyability-green';
    if (monthly <= 60000) return 'buyability-yellow';
    return 'buyability-red';
  }

  // ─── FORMAT ───
  function fmtPrice(p) {
    if (!p) return '—';
    if (p >= 1000000) return (p / 1000000).toFixed(1).replace(/\.0$/, '') + ' млн ₽';
    return new Intl.NumberFormat('ru-RU').format(p) + ' ₽';
  }
  function fmtPriceFull(p) {
    return new Intl.NumberFormat('ru-RU').format(p) + ' ₽';
  }
  function fmtArea(a) {
    const n = parseFloat(a);
    return n % 1 === 0 ? n.toFixed(0) : n.toFixed(1);
  }
  function roomsLabel(r) {
    r = parseInt(r, 10);
    if (r === 0) return 'Студия';
    if (r >= 4) return r + '-комн.';
    return r + '-комн.';
  }

  // (J6: pluralize/fmtPriceRange/диапазоны планировок переехали в общий модуль
  // js/floorplans.js вместе с рендером вида планировок одного ЖК — здесь не нужны.)

  // Сузили ли выдачу ещё до первой загрузки — фильтром в адресе.
  //
  // ⛔ Нужно ровно для одного решения: держать ли серверные карточки в сетке до
  // ответа `/flat_api.php` (см. loadFlats). Сервер печатает выборку ВСЕЙ витрины;
  // при `?rooms=1` или `?price_max=…` она заведомо шире того, что покажет скрипт, и
  // подмена читалась бы как рывок. Ключи перечислены явно, а не взяты из
  // collectFilters(): та читает ЖИВЫЕ поля формы, которые к этому моменту ещё не
  // заполнены, — вопрос же именно про адрес, с которым человек пришёл.
  //
  // `city` и `building_id` в списке НЕ нужны: город и дом называет сам адрес, и
  // выборку сервер собрал именно про них. `sort` тоже нет — порядок карточек
  // сменится, но набор останется тем же.
  const URL_FILTER_KEYS = [
    'rooms', 'rooms_min', 'price_min', 'price_max', 'area_min', 'area_max',
    'floor_min', 'floor_max', 'deadline', 'sections', 'section_numbers', 'discount', 'renovation',
    'installment', 'kind', 'view',
    // 27.09.2026: «Метро и районы» (js/flats-geo.js) — те же имена, что у «Новостроек».
    'metro', 'okrug', 'district', 'place', 'metro_min', 'metro_mode',
  ];

  /** «Метро и районы»: [[имя, значение]] из js/flats-geo.js (нет его — пусто). */
  function geoParams() {
    const g = window.BroniFlatsGeo;
    if (!g || typeof g.params !== 'function') return [];
    try {
      const list = g.params();
      return Array.isArray(list) ? list : [];
    } catch {
      return [];
    }
  }
  function geoCall(name, arg) {
    const g = window.BroniFlatsGeo;
    if (!g || typeof g[name] !== 'function') return;
    try { g[name](arg); } catch { /* окно метро не смеет остановить выдачу */ }
  }
  function hasUrlFilters() {
    const q = new URLSearchParams(location.search);
    return URL_FILTER_KEYS.some(k => q.has(k) && q.get(k) !== '');
  }

  // ─── COLLECT FILTERS ───
  function collectFilters() {
    const f = { city: currentCity };
    if (currentLandingScope) f.landing_scope = currentLandingScope;
    if (currentRooms !== '') {
      if (currentRooms === '4' && new URLSearchParams(location.search).get('from_slice') === '1') f.rooms_min = '4';
      else f.rooms = currentRooms;
    }

    const priceMin = document.getElementById('priceMin');
    const priceMax = document.getElementById('priceMax');
    const areaMin = document.getElementById('areaMin');
    const areaMax = document.getElementById('areaMax');
    const floorMin = document.getElementById('floorMin');
    const floorMax = document.getElementById('floorMax');
    const building = document.getElementById('filterBuilding');
    // 6.1i: фильтр «Застройщик» удалён (юр-имя живёт в 214-блоке страницы ЖК)
    const deadline = document.getElementById('filterDeadline');

    if (priceMin && priceMin.value) f.price_min = priceMin.value;
    if (priceMax && priceMax.value) f.price_max = priceMax.value;
    if (areaMin && areaMin.value) f.area_min = areaMin.value;
    if (areaMax && areaMax.value) f.area_max = areaMax.value;
    if (floorMin && floorMin.value) f.floor_min = floorMin.value;
    if (floorMax && floorMax.value) f.floor_max = floorMax.value;
    if (currentBuilding) f.building_id = currentBuilding;
    else if (building && building.value) f.building_id = building.value;
    if (deadline && deadline.value) f.deadline = deadline.value;
    // jk-smart-filter 1.3: корпуса фильтруют только внутри одного ЖК — в
    // городском списке имя корпуса («Литер 1») ничего не значит и отсекло бы
    // всё подряд. Бэк тоже применяет sections лишь при building_id.
    if (currentSections && (currentBuilding || (building && building.value))) f.sections = currentSections;
    if (f.sections && currentSectionNumbers) f.section_numbers = currentSectionNumbers;
    if (currentDiscount) f.discount = '1';
    if (currentRenovation) f.renovation = currentRenovation;
    if (currentInstallment) f.installment = '1'; // 5.3
    if (currentKind) f.kind = currentKind; // ФИДЫ-2.0 бл.2
    // «Метро и районы» (27.09.2026): только на городской витрине — дом ЖК уже назван.
    // В подборке выбранный ЖК остаётся дополнительным условием: гео из того же
    // адреса продолжает сужать её квартиры. Legacy-витрина одного ЖК — как прежде.
    if (!f.building_id || currentLandingScope) {
      geoParams().forEach(([k, v]) => { if (v !== '' && v != null) f[k] = v; });
    }

    return f;
  }

  // ─── URL SYNC (pushState) ───
  // Адрес выдачи из ТЕКУЩЕГО состояния (фильтры, сортировка, вид) с номером страницы
  // `page`. Одна сборка на два потребителя: строка браузера (syncUrl) и ссылки ряда
  // пагинации (pageHref). ⛔ Доводка r2 блока 7.1: ряд собирал ссылки из location.search,
  // а рисуется он ДО syncUrl() — после смены фильтра или сортировки ссылки несли прежнее
  // состояние, и Ctrl+клик открывал другую выборку.
  function stateUrl(page) {
    const f = collectFilters();
    // Умолчание в адрес не пишем — см. DEFAULT_SORT.
    if (currentSort && currentSort !== DEFAULT_SORT) f.sort = currentSort;
    // Первая страница — без номера: `?page=1` сервер уводит 301-м (ListPageRequest).
    if (page > 1) f.page = page;
    // Вид «Планировки» — в адресе (2026-07-29): ссылку на него должно быть можно
    // отправить и открыть. Плитка/список в URL НЕ пишем: это личное предпочтение,
    // оно живёт в localStorage, и в ссылке только плодило бы варианты одной
    // страницы. Дублей для робота не возникает — canonical у всех видов один
    // (flats.php?city=…, см. flats.php), поэтому вес не размазывается.
    if (currentView === 'plans') f.view = 'plans';

    // F.1: страница квартир ЖК живёт на ЧПУ, и адрес обязан на нём остаться.
    // Условие СТРОГОЕ — «мы на ЧПУ И показываем ИМЕННО тот ЖК, про который этот
    // адрес». Пикер «ЖК» умеет сменить дом без перезагрузки; удержи мы путь при
    // сменившемся доме — под адресом одного комплекса оказалась бы выдача другого.
    // Сменили дом — честно уходим на /flats.php?building_id=, он отдаст 301 куда надо.
    const stayPrettyJk = PINNED_BUILDING !== ''
      && currentBuilding === PINNED_BUILDING
      && /\/kvartiry\/$/.test(location.pathname);

    // ⛔ 14.08.2026: ТО ЖЕ УСЛОВИЕ ДЛЯ ГОРОДСКОЙ ВИТРИНЫ, и оно СТРОГОЕ по той же
    // причине. Адрес /novostroyki/{город}/kvartiry/ объявляет город и «никакого
    // конкретного ЖК». Пикер «ЖК» умеет закрепить дом без перезагрузки, а фильтр
    // городов — сменить город: удержи мы путь в этих случаях, под адресом Москвы
    // оказалась бы выдача Сочи или одного комплекса.
    //
    // ⛔ БЕЗ ЭТОГО КРАСИВЫЙ АДРЕС НЕ ДОЖИВАЛ БЫ ДО ПЕРВОГО ВЗГЛЯДА. syncUrl()
    // вызывается в конце КАЖДОЙ загрузки, включая стартовую, — то есть через ~200 мс
    // после открытия страница сама переписала бы строку браузера на flats.php?city=…
    const stayPrettyCity = PINNED_BUILDING === ''
      && PINNED_CITY !== ''
      && (currentBuilding === '' || currentLandingScope !== '')
      && currentCity === PINNED_CITY
      && /\/kvartiry\/$/.test(location.pathname);

    const stayPretty = stayPrettyJk || stayPrettyCity;

    const params = new URLSearchParams();
    // Служебный маркер удерживает noindex после syncUrl и в ссылках пагинации.
    if (new URLSearchParams(location.search).get('from_slice') === '1') params.set('from_slice', '1');
    for (const [k, v] of Object.entries(f)) {
      if (k === 'sections') continue; // кодируем ниже вручную (%20, не «+»)
      // ЖК уже назван путём — второй раз в query он только плодил бы варианты
      // одного адреса, которые робот обязан различать.
      if (stayPretty && k === 'building_id' && !currentLandingScope) continue;
      // Город тоже назван путём — ровно та же причина. На ЧПУ ЖК (18.09.2026) —
      // так же, как на городской витрине: /novostroyki/{город}/zhk-…/kvartiry/
      // называет город сам, и `?city=` делал из одной страницы вторую.
      // Пишем его только если город сменили и он разошёлся с городом страницы.
      if (stayPrettyCity && k === 'city') continue;
      if (stayPrettyJk && k === 'city' && (SERVER_CITY === '' || v === SERVER_CITY)) continue;
      if (v !== '' && v !== null && v !== undefined) params.set(k, v);
    }
    let query = params.toString();
    // jk-smart-filter 1.3: единый с jk-filter.js формат — имена корпусов
    // с пробелами читаются одинаково и как query, и как путь.
    if (f.sections) query += (query ? '&' : '') + 'sections=' + encodeURIComponent(f.sections);
    return stayPretty
      ? location.pathname + (query ? '?' + query : '')
      : '/flats.php?' + query;
  }

  function syncUrl() {
    const url = stateUrl(currentPage);
    // ⛔ 18.09.2026 (yandex-mobile 1.5): стартовая загрузка — replaceState, а новая
    // запись в истории — только если адрес действительно сменился (действие человека).
    // Прежде pushState шёл на КАЖДОЙ загрузке, включая стартовую и вызванную «Назад»:
    // история росла сама, «Назад» возвращал на ту же страницу.
    // ⛔ 18.09.2026: состояние истории — `{}`, НЕ `null`. Робот Meta (meta-externalagent)
    // исполняет наш JS, перехватывает History API и принимал `null` за адрес: из этой
    // строки рождались 1 201 заход на …/kvartiry/null → 404 за 04–18.09. Сторож —
    // tests/JS/history-state-not-null.test.js.
    if (!urlSyncedOnce) {
      urlSyncedOnce = true;
      history.replaceState({}, '', url);
      return;
    }
    if (url === location.pathname + location.search) return;
    history.pushState({}, '', url);
  }

  // ─── КОРПУС ВИДЕН СОСЕДЯМ (25.09.2026) ───
  // Корпус с генплана — состояние этого файла (`currentSections`), своего контрола в
  // фильтре у него нет. Кнопке «Сбросить» витрины (js/flats-showcase.js) нужно знать,
  // есть ли что сбрасывать: без этого при выбранном ТОЛЬКО корпусе кнопка стояла
  // скрытой, и снять корпус из фильтра было нечем. Отдаём метку на сетке и событие;
  // писатель у метки один — этот файл. Зовётся в начале каждой загрузки (любая смена
  // состояния кончается ею) и из обработчика генплана, где загрузка бывает отложена.
  function markCorpus() {
    if (currentSections) grid.dataset.flatsCorpus = currentSections;
    else delete grid.dataset.flatsCorpus;
    // ⛔ Сигнал соседу не смеет остановить загрузку выдачи: markCorpus() стоит в её
    // начале, и среда без CustomEvent (старый движок, песочница проб) иначе оставила
    // бы страницу без списка. Метка выше уже стоит — сосед прочтёт её при следующем
    // обновлении своей панели.
    try {
      document.dispatchEvent(new CustomEvent('broni:flats-corpus-change'));
    } catch {
      // сообщать некому — выдача важнее
    }
  }

  // ─── ЗАГРУЗКА ПОСЛЕ ТЕКУЩЕЙ ───
  // ⛔ loadFlats() молча выходит, пока идёт прошлая загрузка (`isLoading`). Для действия,
  // которое обязано дойти до выдачи (корпус с генплана, «Сбросить»), это значит «клик
  // пропал»: состояние уже новое, а на экране ответ на старое. Ждём конца текущей
  // загрузки и грузим ТЕКУЩЕЕ состояние — не то, что было на момент клика. `tries` по
  // 100 мс — потолок ожидания: зависший запрос не держит страницу вечно.
  function loadFlatsWhenIdle(tries) {
    if (isLoading && tries > 0) { setTimeout(() => loadFlatsWhenIdle(tries - 1), 100); return; }
    loadFlats();
  }

  // ─── LOAD FLATS ───
  async function loadFlats(append) {
    markCorpus();
    const tab = plansTab();
    if (tab && currentView === 'plans') { openPlansTab(tab); return; }
    if (tab) tab.hide();
    if (isLoading) return;
    isLoading = true;

    if (abortCtrl) abortCtrl.abort();
    abortCtrl = new AbortController();

    const filters = collectFilters();
    // jk-smart-filter 1.3: sections («Литер 1|Литер 2») кодируем сами —
    // URLSearchParams даёт form-urlencoded «+» вместо пробела, а имена корпусов
    // это кириллица с пробелами. Формат ссылок держим единым с jk-filter.js (%20).
    const sections = filters.sections || '';
    delete filters.sections;
    const params = new URLSearchParams(filters);
    params.set('sort', currentSort);
    params.set('page', currentPage);
    // Вид «Планировки» (2026-07-29): тот же фильтр, но каталог свёрнут по типам
    // квартир. Бэк — FlatHandler::listPlansCity; при выбранном ЖК тот же параметр
    // уходит в режим одного ЖК (listPlans), поэтому здесь ветвления не нужно.
    if (currentView === 'plans') {
      params.set('view', 'plans');
    } else if (filters.building_id) {
      // Внутри выбранного ЖК плитка и список — это ПЛОСКИЙ список квартир этого ЖК
      // (view=flats). Без явного вида бэк отдал бы grouped-карточки типов, и
      // переключатель «Плитка/Список» ничего бы не менял: что бы ни выбрал
      // пользователь, он видел бы одно и то же.
      params.set('view', 'flats');
    }

    if (!append) {
      // ⛔ 24.08.2026: СЕРВЕРНЫЕ КАРТОЧКИ НЕ ЗАТИРАЕМ СКЕЛЕТОНАМИ. С этого дня сервер
      // печатает в сетку разнообразную выборку квартир (иначе робот видел на витрине
      // НОЛЬ ссылок на лоты — см. app/lib/Seo/FlatsMarkupSeed.php). Затри мы её здесь
      // ради шести серых плашек — человек увидел бы карточки → плашки → снова
      // карточки, то есть мигание, которого до блока не было.
      //
      // ⛔ ПОЧЕМУ ВЫБРАНА ЗАМЕНА, А НЕ «СКРИПТ ОСТАВЛЯЕТ СЕРВЕРНЫЙ СПИСОК В ПОКОЕ».
      // Второй путь пришлось бы согласовывать с шестью вещами разом — счётчиком
      // «Найдено N», пагинацией, разметкой ItemList, кнопкой «Показать ещё», числами
      // hero и фильтром: сервер отдаёт ВЫБОРКУ ВРАЗБРОС, а не первую страницу
      // выдачи. Замена целиком проще и, главное, исключает двойную отрисовку ПО
      // УСТРОЙСТВУ: renderCards() ниже начинается с полной очистки сетки, поэтому
      // «тридцать квартир дважды» тут получиться не может ни при каком порядке
      // событий. Единственная её цена — карточки один раз сменятся карточками, и
      // чтобы это не читалось как рывок, серверный шаблон печатает ТЕ ЖЕ классы и
      // тот же костяк узлов (app/templates/components/flats-seed-cards.php).
      //
      // ⛔ ДЕРЖИМ СЕРВЕРНУЮ РАЗМЕТКУ, ТОЛЬКО ЕСЛИ ОНА ПРО ТО ЖЕ САМОЕ. Человек с видом
      // «Список» или «Планировки» в localStorage, с фильтром в адресе или на второй
      // странице увидел бы плитку без фильтра, которая через миг превращается во
      // что-то другое, — это рывок заметнее скелетонов. В таких случаях ведём себя
      // как раньше. Робот сюда не попадает вовсе: он приходит на голый адрес.
      // Блок 7.1 (ADR-141): сервер печатает и вторую, третью… страницу — `data-ssr-page`
      // называет, какую. Держим карточки, если показываем ту же; на странице дальше
      // первой — ещё и только при сортировке по умолчанию (иначе набор другой).
      const ssrPage = parseInt(grid.dataset.ssrPage, 10) || 1;
      const ssrHold = grid.dataset.ssr === '1'
        && currentView === 'grid'
        && currentPage === ssrPage
        && (ssrPage === 1 || currentSort === DEFAULT_SORT || currentLandingScope !== '')
        && (!hasUrlFilters() || (currentLandingScope !== '' && grid.dataset.landingScope === currentLandingScope));
      // Метка одноразовая: она описывает ровно ПЕРВУЮ загрузку. Снимаем её всегда, а
      // не только при удержании, — иначе повторный заход в это место (смена фильтра)
      // снова счёл бы клиентские карточки серверными и не показал скелетоны.
      delete grid.dataset.ssr;
      delete grid.dataset.ssrPage;

      if (!ssrHold) {
        grid.innerHTML = '';
        for (let i = 0; i < 6; i++) {
          const sk = document.createElement('div');
          sk.className = 'flat-card flat-card-skeleton';
          grid.appendChild(sk);
        }
      }
    }

    try {
      const query = params.toString()
        + (sections ? '&sections=' + encodeURIComponent(sections) : '');
      const res = await fetch(API + '?action=list&' + query, {
        signal: abortCtrl.signal
      });
      const data = await res.json();

      if (!data.ok) {
        showEmpty();
        isLoading = false;
        return;
      }
      const landingTotal = document.getElementById('flatsLandingTotal');
      if (landingTotal && currentLandingScope) landingTotal.textContent = 'Найдено квартир: ' + data.total + '.';
      const landingHeroTotal = document.getElementById('flatsLandingHeroTotal');
      if (landingHeroTotal) landingHeroTotal.textContent = 'Найдено квартир: ' + data.total + '.';

      // J6 (jk-card-accuracy): каталог одного ЖК (?building_id) рисует ТОТ ЖЕ компонент
      // планировок, что карточка ЖК (jk.php): 4 карточки-типа с чертежами → модалка
      // вариаций (свёрнутый аккордеон этажей + зум чертежа + ссылка на flat.php?id).
      // Общий код — js/floorplans.js (window.BroniFloorplans). Источник — floorplans_by_type
      // (бэк FlatHandler::listGrouped, тот же RoomTypeFloorplans, что jk_manager action=get).
      // Заменяет старый I4-аккордеон. Прячем пагинацию/сортировку (setGroupedMode).
      if (data.grouped) {
        setGroupedMode(true);
        totalFlats = data.total || 0;
        totalPages = 0;
        if (flatsCount) flatsCount.textContent = totalFlats;
        const types = Array.isArray(data.floorplans_by_type) ? data.floorplans_by_type : [];
        grid.className = 'flats-fp-types';
        if (types.length === 0 || !window.BroniFloorplans) {
          showEmpty();
        } else {
          hideEmpty();
          window.BroniFloorplans.render(grid, types);
        }
        isLoading = false;
        syncUrl();
        return;
      }
      // Вид «Планировки» витрины города: карточки типов квартир вместо самих квартир.
      // Сортировку НЕ прячем (в отличие от grouped-вида ЖК) — «сначала дешёвые» здесь
      // работает по крайнему значению диапазона кластера. Постранично — «Показать ещё»
      // по has_more: в Москве планировок ~3400, одним куском страница ляжет.
      if (data.view === 'plans') {
        setPlansMode(true);
        totalFlats = data.total || 0;
        totalPages = 0;
        if (flatsCount) flatsCount.textContent = totalFlats;

        // Режим одного ЖК (listPlans) кладёт дом отдельным полем, а не в карточки —
        // подставляем, иначе карточки внутри ЖК остались бы без подписи.
        const jkName = (data.building && data.building.name) || '';
        const plans = (Array.isArray(data.floorplans) ? data.floorplans : [])
          .map(p => (p.building_name ? p : Object.assign({}, p, {
            building_name: jkName,
            building_id: (data.building && data.building.id) || '',
            plan_uid: ((data.building && data.building.id) || '0') + ':' + p.plan_id,
          })));
        if (plans.length === 0 && !append) {
          showEmpty();
        } else {
          hideEmpty();
          if (append) appendPlanCards(plans); else renderPlanCards(plans);
          if (loadMoreWrap) loadMoreWrap.style.display = data.has_more ? '' : 'none';
        }
        // ⛔ Разметку для робота чистим: в ней лежали ссылки на КВАРТИРЫ прошлой
        // выдачи. Оставить её — значит отдать поисковику список объектов, которых
        // на странице уже нет. Планировки своих адресов не имеют (это срез
        // каталога, а не отдельные страницы), поэтому список пуст.
        updateJsonLd([]);
        isLoading = false;
        syncUrl();
        return;
      }
      setPlansMode(false);
      setGroupedMode(false);

      totalFlats = data.total;
      totalPages = data.pages;

      // Обновить счётчик
      if (flatsCount) flatsCount.textContent = totalFlats;

      if (data.flats.length === 0 && !append) {
        showEmpty();
      } else {
        hideEmpty();
        if (append) {
          appendCards(data.flats);
        } else {
          renderCards(data.flats);
        }
        renderPagination();
        updateJsonLd(data.flats);
      }
    } catch (e) {
      if (e.name !== 'AbortError') {
        console.error('flats load error:', e);
        if (!append) showEmpty();
      }
    }

    isLoading = false;
    syncUrl();
  }

  // ─── ВКЛАДКА «ПЛАНИРОВКИ» ВИТРИНЫ ДОМА (27.09.2026) ───
  // Слово владельца: «блок планировки верхний добавить в нижний, а нижний старый блок
  // планировки убрать». На витрине ОДНОГО дома вид «Планировки» — не своя сетка типов
  // (renderPlanCards ниже: без окна планировки и без панели квартир), а ТОТ ЖЕ блок, что на
  // карточке ЖК; его приносит js/flats-plans-view.js (`window.BroniFlatsPlans`). Фильтр у
  // обеих вкладок один — этот: блок получает ровно тот набор и ту сортировку, с которыми
  // здесь просили бы плитку. Адрес (`?view=plans`), «Назад», «Сбросить», корпус с генплана —
  // прежние: вид — то же состояние `currentView`. На городской витрине вкладки нет, вид
  // «Планировки» там прежний (планировки всего города, listPlansCity).
  function plansTab() {
    const tab = window.BroniFlatsPlans;
    return PINNED_BUILDING && tab && typeof tab.show === 'function' ? tab : null;
  }
  function openPlansTab(tab) {
    // Летящая выдача плитки больше не нужна: доехав, она нарисовала бы ряд страниц и
    // разметку ItemList под чужой вкладкой.
    if (abortCtrl) { abortCtrl.abort(); abortCtrl = null; }
    isLoading = false;
    // Серверные карточки больше не «ждут»: вернувшись на плитку, человек увидит выдачу по
    // текущему фильтру, а не серверную выборку.
    delete grid.dataset.ssr;
    delete grid.dataset.ssrPage;
    // Разметка для робота — только про видимое: квартир под этой вкладкой на экране нет
    // (так же поступал и прежний вид «Планировки»).
    updateJsonLd([]);
    tab.show(collectFilters(), currentSort);
    syncUrl();
  }

  // ─── RENDER CARDS ───
  function renderCards(flats) {
    grid.innerHTML = '';
    grid.className = currentView === 'list' ? 'flats-list' : 'flats-grid';
    appendCards(flats);
  }

  function appendCards(flats) {
    const frag = document.createDocumentFragment();
    flats.forEach((f, i) => {
      frag.appendChild(currentView === 'list' ? createListCard(f, i) : createGridCard(f, i));
    });
    grid.appendChild(frag);
  }

  /* ──────────────────────────────────────────────────────────────────────────
     МИНИАТЮРЫ ЧЕРЕЗ /img-thumb.php (2026-09-10, блок 2.1 плана local-stand)

     ⛔ ЧТО ЛЕЧИМ. Этот файл — единственный отрисовщик карточек квартир, который
     ставил в `src` АДРЕС ЗАСТРОЙЩИКА КАК ЕСТЬ. Соседи так не делают: серверная
     затравка тех же карточек идёт через `thumbProxyUrl($fImg, 800)`
     (app/templates/components/flats-seed-cards.php:111), сводка планировок —
     через `thumbUrl()` (public/js/flats-showcase.js:1396), карта — через свой
     (public/js/catalog-map.js:114). То есть первая отрисовка страницы была
     сжатой, а после первого же фильтра или подгрузки те же карточки уезжали
     за ОРИГИНАЛАМИ: планировки застройщиков идут по несколько мегабайт под
     плитку 320 px — ровно та регрессия трафика, ради которой прокси и заведён
     (ADR-090, 36,6 МБ на открытие карты).

     Найдено замером Playwright на локальном стенде: страница витрины квартир
     города дала 5 запросов на `pb16162.profitbase.ru` в обход `localhost`,
     при том что в исходном HTML ни одного прямого адреса нет.

     Правила повторяют flats-showcase.js дословно (кодирование по RFC 3986 —
     иначе у прокси два файла на один кадр; своя папка только для
     /img/building_renders — мелкий ассет через прокси стал бы ТЯЖЕЛЕЕ оригинала).
     ────────────────────────────────────────────────────────────────────────── */
  const LOCAL_THUMBABLE = /^\/img\/building_renders\/[\w./-]+\.(?:jpe?g|png|webp)$/i;
  const rawUrlEncode = (s) => encodeURIComponent(s)
    .replace(/[!'()*]/g, (c) => '%' + c.charCodeAt(0).toString(16).toUpperCase());

  function thumbUrl(src, w) {
    if (!src || typeof src !== 'string') return '';
    let url = src.trim();
    if (url === '') return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    url = url.replace(/^https?:\/\/(?:www\.)?bronidom\.ru(?=\/)/i, '');
    const width = w || 320;
    if (/^https?:\/\//i.test(url)) return '/img-thumb.php?src=' + rawUrlEncode(url) + '&w=' + width;
    if (LOCAL_THUMBABLE.test(url) && url.indexOf('..') < 0) {
      return '/img-thumb.php?src=' + rawUrlEncode(url) + '&w=' + width;
    }
    return url; // не картинка (svg-заглушка, data:) — отдаём как есть
  }

  function createGridCard(f) {
    const card = document.createElement('a');
    card.href = '/flat.php?id=' + f.id;
    card.className = 'flat-card';
    // U.1: клик = переход на страницу квартиры; цель Метрики вешаем на саму ссылку
    // (общий делегат [data-ym] в utils.js — inline-обработчики запрещены CSP).
    card.setAttribute('data-ym', 'flats_card_open');
    // 25.09.2026: корпус квартиры — ключ кнопки «На генплане». Саму кнопку ставит
    // js/jk-genplan.js, и только если у ЖК есть генплан с обводкой и корпус однозначен.
    if (PINNED_BUILDING && f.section) card.dataset.flatSection = String(f.section);

    // block #31b: layout_url и photos[] приходят СЕРВЕРНО-решёнными (LayoutPolicy —
    // поэтажники/склейки вычищены на бэке). Честный fallback обложки: план → санированное
    // фото → фото ЖК. Раньше при пустом layout_url и пустых photos рендерилась битая
    // <img src=""> (building_image проверялся, но не использовался как src).
    const photos = f.photos || [];
    const allImgs = [];
    if (f.layout_url) allImgs.push(f.layout_url);
    photos.forEach(p => { if (p && allImgs.indexOf(p) === -1) allImgs.push(p); });
    const photoCount = allImgs.length;

    // ⛔ 28.09.2026: фото дома (building_image) в место ПЛАНИРОВКИ не подставляем — владелец:
    // «в месте планировки только чертёж». Явный card_render_url разрешён как фото
    // с подписью «Рендер ЖК» (слово владельца по «Достижению», 10.10.2026).
    const primaryImg = allImgs[0] || '';
    const render = !primaryImg && f.card_render_url ? f.card_render_url : '';

    // ─ Шапка: ЖК (проект) + тег с типом квартиры — как «проект + тип» у коммерции.
    const headHtml = '<div class="flat-card-head">'
      + '<span class="flat-card-project">' + esc(f.building_name || 'Новостройка') + '</span>'
      + '<span class="flat-card-tag">' + esc(roomsLabel(f.rooms)) + '</span>'
      + '</div>';

    // ─ Крупная обложка-планировка на светлой панели (как mr-group/коммерция).
    // Бейджи сохранены: «Популярное» (слева сверху), фото-счётчик (слева снизу),
    // просмотры (справа снизу) — ни один параметр карточки не потерян.
    const popularBadge = f.views >= 50 ? '<span class="flat-card-popular-badge"><i class="fa-solid fa-fire"></i> Популярное</span>' : '';
    const photoBadge = photoCount > 1 ? '<span class="flat-card-photo-badge"><i class="fa-solid fa-camera"></i> ' + esc(String(photoCount)) + '</span>' : '';
    const viewsBadge = '<span class="flat-card-views-badge"><i class="fa-regular fa-eye"></i> ' + esc(String(f.views || 0)) + '</span>';

    // ─ Галерея-плашки (референс «МОД», владелец 2026-07-14): ровно ПЛАН + ПОЭТАЖНИК.
    // План = серверно-решённый layout_url (LayoutPolicy). Поэтажник = серверное поле
    // floor_scheme_url (тот же SSOT, что раздел «Поэтажный план» flat.php / оверлей) —
    // JS не детектит по имени. Нет поэтажника → одно фото, плашек нет. Рендеры ЖК в
    // карточку КВАРТИРЫ не попадают (floor_scheme_url их не отдаёт).
    const plan = primaryImg;
    const floorScheme = (f.floor_scheme_url && f.floor_scheme_url !== plan) ? f.floor_scheme_url : '';
    const galleryList = [];
    if (plan) galleryList.push({ src: plan, label: 'Планировка' });
    if (render) galleryList.push({ src: render, label: 'Рендер ЖК' });
    // Без плана поэтажник обложкой не встаёт: он оказался бы в месте планировки (28.09.2026).
    if (plan && floorScheme) galleryList.push({ src: floorScheme, label: 'Поэтажник' });
    const galCount = galleryList.length;
    const altFirst = esc(render ? 'Рендер ЖК' : roomsLabel(f.rooms) + ' ' + fmtArea(f.area) + ' м²');
    const galleryImgsHtml = galleryList.map((g, i) =>
      // 800 — та же ширина, что у серверной затравки этих же карточек
      // (flats-seed-cards.php:111): один ключ кэша на оба пути отрисовки.
      '<img src="' + esc(thumbUrl(g.src, 800)) + '" alt="' + (i === 0 ? altFirst : esc(g.label)) + '" class="flat-card-image'
      + (i === 0 ? ' active' : '') + '"' + (i === 0 ? '' : ' loading="lazy"') + '>'
    ).join('');
    // Segmented-плашки (только при >1 фото). Наведение/тап по плашке → её фото. data-gal-pill=idx.
    const pillsHtml = galCount > 1
      ? '<div class="flat-card-gal-pills">'
        + galleryList.map((g, i) =>
            '<button type="button" class="flat-card-gal-pill' + (i === 0 ? ' active' : '')
            + '" data-gal-pill="' + i + '" aria-label="' + esc(g.label) + '"></button>'
          ).join('')
        + '</div>'
      : '';
    const imgInner = galCount > 0
      ? '<div class="flat-card-gallery" data-gallery data-idx="0">' + galleryImgsHtml + '</div>' + pillsHtml
      : '<div class="flat-card-image flat-card-noimg flat-card-noplan"><i class="fa-solid fa-ruler-combined" aria-hidden="true"></i><span>Планировка уточняется</span></div>';
    const renderBadge = render ? '<span class="flat-card-photo-badge">Рендер ЖК</span>' : '';
    const imgHtml = '<div class="flat-card-img-wrap">' + imgInner + popularBadge + photoBadge + viewsBadge + renderBadge + '</div>';

    // B1: BuyAbility — ежемесячный платёж (сохранён)
    const monthly = f.price > 0 ? calcMonthly(f.price, 20, 6, 25) : 0;
    const baClass = monthly > 0 ? buyAbilityClass(monthly) : '';
    const monthlyHtml = monthly > 0
      ? '<span class="flat-card-monthly ' + baClass + '"><i class="fa-solid fa-calculator"></i> от ' + esc(new Intl.NumberFormat('ru-RU').format(monthly)) + ' ₽/мес</span>'
      : '';

    // Скидка застройщика. Микроскидки <3% — шум округления фидов, скрываем (5.1).
    const priceOld = parseInt(f.price_old, 10) || 0;
    const discountPct = (priceOld > 0 && priceOld > f.price)
      ? Math.floor((priceOld - f.price) / priceOld * 100)
      : 0;
    const hasDiscount = discountPct >= DISCOUNT_MIN_PCT;
    const discountBadgeHtml = hasDiscount
      ? '<span class="flat-card-discount-badge">−' + discountPct + '%</span>'
      : '';
    const priceOldHtml = hasDiscount
      ? '  <div class="flat-card-price-old">' + esc(fmtPriceFull(priceOld)) + '</div>'
      : '';

    // ─ Строка: площадь ⇄ цена (золото-градиент). Discount-бейдж — вне gradient-clip.
    const rowHtml = '<div class="flat-card-row">'
      + '<span class="flat-card-area">' + esc(fmtArea(f.area)) + ' м²</span>'
      + '<span class="flat-card-price-wrap"><span class="flat-card-price">' + esc(fmtPriceFull(f.price)) + '</span>' + discountBadgeHtml + '</span>'
      + '</div>';

    // ─ ₽/м² + ежемесячный платёж по ипотеке — строкой ниже (сохранены).
    const subRowHtml = '<div class="flat-card-subrow">'
      + '<span class="flat-card-m2">' + esc(new Intl.NumberFormat('ru-RU').format(f.price_m2)) + ' ₽/м²</span>'
      + monthlyHtml
      + '</div>';

    // ─ Подвал: мета (этаж · город) ⇄ «Подробнее» на hover (как коммерция).
    // 6.1i: юр-имя застройщика («ООО СЗ…») убрано — название ЖК уже в шапке
    // карточки (flat-card-project), наименование застройщика живёт в
    // обязательном 214-блоке страницы ЖК.
    const metaParts = [];
    // ФИДЫ-2.0 бл.2: «Апартаменты» — ПЕРВЫМ в мете, раньше этажа и города.
    // Это не украшательство, а юридическая маркировка: апартаменты — нежилое
    // помещение (нет постоянной прописки, выше налог и коммуналка). Покупатель
    // обязан увидеть класс помещения ещё в списке, а не только зайдя в карточку.
    // f.is_apartment приходит УЖЕ разрешённым лесенкой (FlatHandler::list) — здесь
    // не складываем флаг фида с пометкой ЖК, иначе каталог разъедется со страницей.
    if (f.is_apartment) metaParts.push('<span class="flat-card-apart"><i class="fa-solid fa-file-signature"></i> Апартаменты</span>');
    metaParts.push(esc(String(f.floor)) + (f.floors_total ? '/' + esc(String(f.floors_total)) : '') + ' эт.');
    metaParts.push(esc(f.city_name || cityNom(f.city)));
    // B2.2: строка «Паркинг» (паркинг здания квартиры). Free FA fa-car. Статичный HTML — без user-data.
    // 5.2 fix-раунд: отделка ВАЖНЕЕ паркинга — выше в мете (на 390 обрезается хвост)
    if (f.renovation_label) metaParts.push('<span class="flat-card-reno"><i class="fa-solid fa-paint-roller"></i> ' + esc(f.renovation_label) + '</span>');
    // 5.3: бейдж «Рассрочка» — УТП застройщика (график платежей). Выше паркинга.
    if (f.installment) metaParts.push('<span class="flat-card-installment"><i class="fa-solid fa-scale-balanced"></i> Рассрочка</span>');
    if (f.parking_type) metaParts.push('<i class="fa-solid fa-car"></i> Паркинг');
    const footHtml = '<div class="flat-card-foot">'
      + '<span class="flat-card-meta">' + metaParts.join(' · ') + '</span>'
      + '<span class="flat-card-cta"><i class="fa-solid fa-arrow-right"></i> Подробнее</span>'
      + '</div>';

    card.innerHTML = headHtml
      + imgHtml
      + '<div class="flat-card-body">'
      + priceOldHtml
      + rowHtml
      + subRowHtml
      + (card.dataset.flatSection ? '<div class="flat-card-genplan" data-genplan-show-slot></div>' : '')
      + footHtml
      + '</div>';

    return card;
  }

  function createListCard(f) {
    const card = document.createElement('a');
    card.href = '/flat.php?id=' + f.id;
    card.className = 'flat-card-list';
    card.setAttribute('data-ym', 'flats_card_open'); // U.1: та же цель, что у плиточной карточки
    if (PINNED_BUILDING && f.section) card.dataset.flatSection = String(f.section); // кнопка «На генплане»

    // 28.09.2026: без фото дома в месте планировки (как у плиточной карточки).
    const render = !f.layout_url && f.card_render_url ? f.card_render_url : '';
    const img = f.layout_url || render;

    card.innerHTML =
        '<div class="flat-list-img">'
      // Списочная карточка узкая (плитка ~120 px), поэтому 320, а не 800.
      + (img ? '<img src="' + esc(thumbUrl(img, 320)) + '" alt="' + (render ? 'Рендер ЖК' : '') + '" loading="lazy">' : '<i class="fa-solid fa-ruler-combined" title="Планировка уточняется" aria-label="Планировка уточняется"></i>')
      + '</div>'
      + '<div class="flat-list-info">'
      + '  <span class="flat-list-specs">' + esc(roomsLabel(f.rooms)) + ' · ' + esc(fmtArea(f.area)) + ' м² · ' + esc(String(f.floor)) + (f.floors_total ? '/' + esc(String(f.floors_total)) : '') + ' эт.' + (f.parking_type ? ' · <i class="fa-solid fa-car"></i> Паркинг' : '') + '</span>'
      // 6.1i: только название ЖК (юр-имя застройщика убрано — 214-блок страницы ЖК)
      + '  <span class="flat-list-jk">' + esc(f.building_name || '') + '</span>'
      + (render ? '  <span>Рендер ЖК</span>' : '')
      + (card.dataset.flatSection ? '  <span class="flat-card-genplan" data-genplan-show-slot></span>' : '')
      + '</div>'
      + '<div class="flat-list-price">'
      + '  <span class="flat-list-price-val">' + esc(fmtPriceFull(f.price)) + '</span>'
      + '  <span class="flat-list-price-m2">' + esc(new Intl.NumberFormat('ru-RU').format(f.price_m2)) + ' ₽/м²</span>'
      + '</div>';

    return card;
  }

  // ═══ J6: ВИД ПЛАНИРОВОК ОДНОГО ЖК (общий компонент с jk.php) ═══
  // Каталог, суженный до одного ЖК (?building_id), рисует ТОТ ЖЕ UI, что карточка ЖК:
  // 4 карточки-типа с чертежами → модалка вариаций. Рендер/модалка/зум — в общем модуле
  // js/floorplans.js (window.BroniFloorplans), вызывается из loadFlats (ветка data.grouped).
  // Здесь — только переключатель режима (прячет пагинацию/сортировку). Старый I4-аккордеон
  // (строки-планировки с инлайн-этажами) удалён в пользу DRY-компонента floorplans.js.

  // Переключение «плоский каталог ⇄ вид планировок одного ЖК».
  function setGroupedMode(on) {
    document.body.classList.toggle('flats-grouped-mode', on);
    // ⚠️ 29.07.2026 (замечание владельца): панель БОЛЬШЕ НЕ ПРЯЧЕМ. Раньше выбор
    // ЖК в фильтре убирал её целиком — вместе с сортировкой и переключателем вида,
    // и пользователь оказывался заперт в одном представлении без видимой причины
    // («нажимаю Догма — плашки пропадают»). Виды внутри ЖК поддержаны все три:
    // плитка/список идут через view=flats, планировки — через view=plans.
    if (on) {
      if (pagination) { pagination.style.display = 'none'; pagination.innerHTML = ''; }
      if (loadMoreWrap) loadMoreWrap.style.display = 'none';
    }
  }

  // ─── СЛАЙДЕРЫ ДИАПАЗОНОВ (2026-07-29) ───
  // Гибрид «слайдер + поле», как на карточке ЖК: мышью грубо, руками точно.
  // Границы берём из фасетов (живые данные города), а не выдумываем: «от 0 до
  // 30 млн» врало бы в обе стороны — в Курске потолок втрое ниже, в Москве выше.
  //
  // ⚠️ Источник истины — ЧИСЛОВЫЕ ПОЛЯ. Слайдер только пишет в них и читает из них;
  // collectFilters по-прежнему смотрит на поля. Иначе появился бы второй источник
  // состояния, и значения разъезжались бы при восстановлении из URL.
  const SLIDERS = [
    { key: 'price', minInput: 'priceMin', maxInput: 'priceMax', rangeMin: 'priceRangeMin', rangeMax: 'priceRangeMax', fill: 'priceFill', box: 'priceSlider', step: 100000 },
    { key: 'area',  minInput: 'areaMin',  maxInput: 'areaMax',  rangeMin: 'areaRangeMin',  rangeMax: 'areaRangeMax',  fill: 'areaFill',  box: 'areaSlider',  step: 1 },
    { key: 'floor', minInput: 'floorMin', maxInput: 'floorMax', rangeMin: 'floorRangeMin', rangeMax: 'floorRangeMax', fill: 'floorFill', box: 'floorSlider', step: 1 },
  ];

  function sliderEls(cfg) {
    return {
      box: document.getElementById(cfg.box),
      rMin: document.getElementById(cfg.rangeMin),
      rMax: document.getElementById(cfg.rangeMax),
      fill: document.getElementById(cfg.fill),
      iMin: document.getElementById(cfg.minInput),
      iMax: document.getElementById(cfg.maxInput),
    };
  }

  function paintSlider(cfg) {
    const el = sliderEls(cfg);
    if (!el.rMin || !el.rMax || !el.fill) return;
    const lo = Number(el.rMin.min), hi = Number(el.rMin.max);
    if (!(hi > lo)) return;
    const a = Math.min(Number(el.rMin.value), Number(el.rMax.value));
    const b = Math.max(Number(el.rMin.value), Number(el.rMax.value));
    el.fill.style.left = ((a - lo) / (hi - lo) * 100) + '%';
    el.fill.style.right = (100 - (b - lo) / (hi - lo) * 100) + '%';
  }

  /** Границы из фасетов → показать слайдер. Пустой диапазон оставляет его скрытым. */
  function setupSlider(cfg, range) {
    const el = sliderEls(cfg);
    if (!el.box || !el.rMin || !el.rMax) return;

    const lo = Math.floor(Number(range && range.min) || 0);
    const hi = Math.ceil(Number(range && range.max) || 0);
    if (!(hi > lo)) { el.box.hidden = true; return; }

    [el.rMin, el.rMax].forEach(r => { r.min = String(lo); r.max = String(hi); r.step = String(cfg.step); });
    el.rMin.value = String(el.iMin && el.iMin.value !== '' ? el.iMin.value : lo);
    el.rMax.value = String(el.iMax && el.iMax.value !== '' ? el.iMax.value : hi);
    el.box.hidden = false;
    paintSlider(cfg);

    if (el.box._bronidomBound) return;
    el.box._bronidomBound = true;

    const push = () => {
      // Ползунки могут перехлестнуться — нормализуем, иначе «от» станет больше «до»
      // и выдача окажется пустой без видимой причины.
      const a = Math.min(Number(el.rMin.value), Number(el.rMax.value));
      const b = Math.max(Number(el.rMin.value), Number(el.rMax.value));
      if (el.iMin) el.iMin.value = a > lo ? String(a) : '';
      if (el.iMax) el.iMax.value = b < hi ? String(b) : '';
      paintSlider(cfg);
    };

    [el.rMin, el.rMax].forEach(r => {
      r.addEventListener('input', push);
      r.addEventListener('change', () => { currentPage = 1; loadFlats(); });
    });

    // Обратная связь: правка руками двигает ползунок.
    [el.iMin, el.iMax].forEach((inp, idx) => {
      if (!inp) return;
      inp.addEventListener('input', () => {
        const target = idx === 0 ? el.rMin : el.rMax;
        const fallback = idx === 0 ? lo : hi;
        const v = inp.value === '' ? fallback : Number(inp.value);
        if (!Number.isNaN(v)) target.value = String(Math.min(Math.max(v, lo), hi));
        paintSlider(cfg);
      });
    });
  }

  // ─── PLANS VIEW (витрина города) ───
  // Отдельно от grouped-вида ЖК: там карточки типов рисует js/floorplans.js и прячет
  // сортировку. Здесь сортировка нужна, карточек тысячи, и у каждой обязателен ЖК —
  // «Студия 25 м² от 6,2 млн» без дома на витрине города бессмысленна.
  function setPlansMode(on) {
    document.body.classList.toggle('flats-plans-mode', on);
    if (on) {
      if (pagination) { pagination.style.display = 'none'; pagination.innerHTML = ''; }
    }
  }

  function renderPlanCards(plans) {
    grid.innerHTML = '';
    grid.className = 'flats-plans-grid';
    appendPlanCards(plans);
  }

  function appendPlanCards(plans) {
    const frag = document.createDocumentFragment();
    plans.forEach(p => frag.appendChild(createPlanCard(p)));
    grid.appendChild(frag);
  }

  /** Карточка типа квартиры: чертёж, метраж, цена «от», ЖК и сколько таких в продаже. */
  function createPlanCard(p) {
    const card = document.createElement('button');
    card.type = 'button';
    card.className = 'flats-plan-card';
    card.dataset.planUid = p.plan_uid || '';
    card.dataset.buildingId = String(p.building_id || '');
    card.dataset.rooms = String(p.rooms);
    card.dataset.areaMin = String(p.area_min);
    card.dataset.areaMax = String(p.area_max);
    card.setAttribute('data-ym', 'flats_plan_card');

    const areaTxt = (p.area_min === p.area_max)
      ? fmtArea(p.area_min) + ' м²'
      : fmtArea(p.area_min) + '–' + fmtArea(p.area_max) + ' м²';

    const cover = document.createElement('span');
    cover.className = 'flats-plan-card__cover';
    const render = !p.layout_url && p.card_render_url ? p.card_render_url : '';
    if (p.layout_url || render) {
      const img = document.createElement('img');
      // ⛔ ВИД «ПЛАНИРОВКИ» ШЁЛ МИМО УМЕНЬШИТЕЛЯ. Правка выше (карточки квартир)
      // закрыла два отрисовщика из трёх, а этот остался: замер верификатора 10.09
      // на `?view=plans` — 24 карточки и 21 запрос на CDN застройщиков
      // (`pb16162.profitbase.ru`, `bitrix.1dogma.net`, `cdn.a101.ru`,
      // `crmwebexternal.gk-osnova.ru`), то есть браузер каждого посетителя тянул
      // многомегабайтные чертежи под плитку 320 px. Ровно та регрессия трафика,
      // ради которой прокси и заведён (ADR-090).
      // Ширина 320 — как у такой же плитки планировки в соседней сводке
      // (`public/js/flats-showcase.js:1343`), чтобы ключ кэша был ОДИН на кадр.
      img.src = thumbUrl(p.layout_url || render, 320);
      img.alt = render ? 'Рендер ЖК' : (p.label || '') + ' ' + areaTxt;
      img.loading = 'lazy';
      cover.appendChild(img);
      if (render) {
        const caption = document.createElement('span');
        caption.textContent = 'Рендер ЖК';
        cover.appendChild(caption);
      }
    } else {
      cover.classList.add('flats-plan-card__cover--empty');
    }
    card.appendChild(cover);

    // ⛔ Только textContent: имена ЖК приходят из фидов застройщиков.
    const body = document.createElement('span');
    body.className = 'flats-plan-card__body';

    const title = document.createElement('span');
    title.className = 'flats-plan-card__title';
    title.textContent = (p.label || roomsLabel(p.rooms)) + ' · ' + areaTxt;
    body.appendChild(title);

    const price = document.createElement('span');
    price.className = 'flats-plan-card__price';
    price.textContent = p.price_min ? 'от ' + fmtPrice(p.price_min) : 'цена по запросу';
    body.appendChild(price);

    const jk = document.createElement('span');
    jk.className = 'flats-plan-card__jk';
    jk.textContent = p.building_name || '';
    body.appendChild(jk);

    const cnt = document.createElement('span');
    cnt.className = 'flats-plan-card__count';
    cnt.textContent = p.count + ' ' + plural(p.count, 'квартира', 'квартиры', 'квартир');
    body.appendChild(cnt);

    card.appendChild(body);

    return card;
  }

  function plural(n, one, few, many) {
    const m10 = n % 10, m100 = n % 100;
    if (m10 === 1 && m100 !== 11) return one;
    if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few;
    return many;
  }

  // Клик по планировке → те же квартиры в обычном виде: подставляем дом, комнатность
  // и диапазон площади в фильтр и уходим в «Плитку». Пользователь видит ровно те
  // квартиры, что стоят за карточкой, и может дальше крутить этаж и цену.
  // ⛔ Возврат к планировкам (слово владельца 27.09.2026: «нажал на планировку, в которой
  // 3 квартиры, — меня перекинуло на 3 квартиры; нужна понятная кнопка на видном месте
  // назад к планировкам, и на компе, и на телефоне»). Перед переходом запоминаем фильтр,
  // страницу и прокрутку «Планировок»; кнопка над выдачей возвращает ровно туда же.
  let plansReturn = null;
  const plansBack = document.createElement('div');
  plansBack.className = 'flats-plans-back container';
  plansBack.hidden = true;
  const plansBackBtn = document.createElement('button');
  plansBackBtn.type = 'button';
  plansBackBtn.className = 'flats-plans-back__btn';
  // Постоянная строка без данных пользователя — innerHTML здесь безопасен.
  plansBackBtn.innerHTML = '<i class="fas fa-arrow-left" aria-hidden="true"></i> Назад к планировкам';
  plansBack.appendChild(plansBackBtn);
  // Над сеткой «выдача + боковая панель», а не внутри неё: в сетке лишний ребёнок
  // сдвигал выдачу под панель опроса (замер на стенде 27.09: первая квартира на 984 px
  // при кнопке на 296). Строка «Найдено… Сортировка» — сразу над кнопкой.
  const plansBackAnchor = document.querySelector('.flats-toolbar-section');
  if (plansBackAnchor && plansBackAnchor.after) plansBackAnchor.after(plansBack);
  else if (grid.parentNode) grid.parentNode.insertBefore(plansBack, grid);
  const applyPlanFilter = (building, rooms, areaMin, areaMax) => {
    currentBuilding = building;
    currentRooms = rooms;
    const aMin = document.getElementById('areaMin');
    const aMax = document.getElementById('areaMax');
    if (aMin) aMin.value = areaMin;
    if (aMax) aMax.value = areaMax;
    const picker = document.getElementById('filterBuilding');
    if (picker) picker.value = currentBuilding;
    document.querySelectorAll('#roomsBtns .room-btn').forEach(b => {
      b.classList.toggle('active', (b.dataset.rooms || '') === currentRooms);
    });
  };
  const dropPlansReturn = () => { plansReturn = null; plansBack.hidden = true; };
  plansBackBtn.addEventListener('click', () => {
    if (!plansReturn) return;
    const back = plansReturn;
    dropPlansReturn();
    applyPlanFilter(back.building, back.rooms, back.areaMin, back.areaMax);
    currentView = 'plans';
    localStorage.setItem('flats_view', currentView);
    syncViewButtons();
    currentPage = back.page;
    Promise.resolve(loadFlats()).then(() => window.scrollTo({ top: back.scrollY }));
  });

  grid.addEventListener('click', (e) => {
    const card = e.target.closest('.flats-plan-card');
    if (!card || !document.body.classList.contains('flats-plans-mode')) return;

    const aMinNow = document.getElementById('areaMin');
    const aMaxNow = document.getElementById('areaMax');
    plansReturn = {
      building: currentBuilding, rooms: currentRooms,
      areaMin: aMinNow ? aMinNow.value : '', areaMax: aMaxNow ? aMaxNow.value : '',
      page: currentPage, scrollY: window.scrollY,
    };
    currentBuilding = card.dataset.buildingId || '';
    currentRooms = card.dataset.rooms || '';
    const aMin = document.getElementById('areaMin');
    const aMax = document.getElementById('areaMax');
    if (aMin) aMin.value = card.dataset.areaMin || '';
    if (aMax) aMax.value = card.dataset.areaMax || '';
    // Пикер ЖК и чипы комнатности — чтобы фильтр показывал то же, что применилось.
    // Иначе выдача сузилась бы до одного дома, а контролы остались бы «любой».
    const picker = document.getElementById('filterBuilding');
    if (picker) picker.value = currentBuilding;
    document.querySelectorAll('#roomsBtns .room-btn').forEach(b => {
      b.classList.toggle('active', (b.dataset.rooms || '') === currentRooms);
    });

    currentView = 'grid';
    localStorage.setItem('flats_view', currentView);
    syncViewButtons();
    currentPage = 1;
    plansBack.hidden = false;
    Promise.resolve(loadFlats()).then(() => { if (plansBack.scrollIntoView) plansBack.scrollIntoView({ block: 'start', behavior: 'smooth' }); });
  });

  // Рендер вида планировок одного ЖК делегирован общему модулю js/floorplans.js
  // (карточки-типы → модалка вариаций + зум + ссылка на flat.php?id). Клики по
  // карточкам-типам / чертежам / шапкам обрабатывают глобальные делегаты модуля —
  // отдельные обработчики здесь не нужны.

  // ─── PAGINATION ───
  function renderPagination() {
    if (!pagination) return;
    const isMobile = window.innerWidth < 768;

    // ВАЖНО-7: "Показать ещё" на мобильном
    // ⛔ Доводка r3 блока 7.1 (P2-3 Codex r2): ряд на телефоне ПРЯЧЕТСЯ, но пересобирается
    // так же, как на широком экране. Прежде эта ветка выходила раньше сборки, и после смены
    // фильтра в скрытом ряду оставались ссылки прежней выдачи (`?page=2` без `rooms=2`) —
    // DOM расходился с выдачей, а робот, исполняющий скрипт, читал именно их.
    if (isMobile) {
      pagination.style.display = 'none';
      if (loadMoreWrap) {
        loadMoreWrap.style.display = currentPage < totalPages ? '' : 'none';
      }
    } else {
      if (loadMoreWrap) loadMoreWrap.style.display = 'none';
      pagination.style.display = '';
    }

    if (totalPages <= 1) { pagination.innerHTML = ''; return; }

    // ⛔ Блок 7.1 «Фид Яндекса» (24.09.2026, ADR-141): ССЫЛКИ, А НЕ КНОПКИ. Тот же ряд
    // сервер печатает до скрипта (\BroniDom\Seo\ListPager::links(), правила ряда — те
    // же семь кнопок, стрелки и «…»). Рисуй мы здесь по-прежнему <button>, робот,
    // исполняющий JS (Яндекс исполняет), после отрисовки потерял бы все ссылки на
    // вторую страницу и дальше. Клик по-прежнему перехватывает делегат ниже —
    // человек листает без перезагрузки, как раньше. Вид тот же: `a{color:inherit;
    // text-decoration:none}` в main.css, остальное задаёт класс `page-btn`.
    let html = '';
    const maxBtns = 7;
    let start = Math.max(1, currentPage - 3);
    let end = Math.min(totalPages, start + maxBtns - 1);
    if (end - start < maxBtns - 1) start = Math.max(1, end - maxBtns + 1);

    // ⛔ Доводка r3 блока 7.1 (ADR-141 п. 8): ссылки на страницы 2+ — `rel="nofollow"`
    // (те страницы отдают `noindex, nofollow`), ссылка на первую — обычная. Токен в том же
    // `rel`, что `prev`/`next`, и в том же порядке атрибутов, что у серверного компонента
    // (components/list-pager-links.php): ряд перерисовывается байт-в-байт.
    const rel = (page, word) => {
      const tokens = (word ? [word] : []).concat(page > 1 ? ['nofollow'] : []);
      return tokens.length ? ' rel="' + tokens.join(' ') + '"' : '';
    };
    const link = (page, cls, inner, extra) => '<a class="' + cls + '" href="' + pageHref(page)
      + '" data-page="' + page + '"' + (extra || '') + '>' + inner + '</a>';

    if (currentPage > 1) {
      html += link(currentPage - 1, 'page-btn', '<i class="fa-solid fa-chevron-left"></i>', rel(currentPage - 1, 'prev') + ' aria-label="Предыдущая страница"');
    }
    if (start > 1) {
      html += link(1, 'page-btn', '1');
      if (start > 2) html += '<span class="page-dots">...</span>';
    }
    for (let i = start; i <= end; i++) {
      html += link(i, 'page-btn' + (i === currentPage ? ' active' : ''), String(i), rel(i, '') + (i === currentPage ? ' aria-current="page"' : ''));
    }
    if (end < totalPages) {
      if (end < totalPages - 1) html += '<span class="page-dots">...</span>';
      html += link(totalPages, 'page-btn', String(totalPages), rel(totalPages, ''));
    }
    if (currentPage < totalPages) {
      html += link(currentPage + 1, 'page-btn', '<i class="fa-solid fa-chevron-right"></i>', rel(currentPage + 1, 'next') + ' aria-label="Следующая страница"');
    }

    pagination.innerHTML = html;
  }

  // Адрес страницы N — из ТЕКУЩЕГО состояния выдачи, той же сборкой, что строка браузера
  // (stateUrl). Первая страница — БЕЗ номера: `?page=1` сервер уводит 301-м
  // (ListPageRequest), ссылка на него гоняла бы робота через редирект. Фильтры и
  // сортировка — те, что показаны СЕЙЧАС, а не те, что были в адресе до клика.
  function pageHref(page) {
    return stateUrl(page);
  }

  // ─── STATS ───
  async function loadStats() {
    // На scoped витрине число пишет тот же ответ выдачи, включая reset/back.
    // Городской агрегат над этой подборкой давал бы другое «Найдено N».
    if (document.getElementById('flatsLandingHeroTotal')) return;
    try {
      const res = await fetch(API + '?action=stats&city=' + currentCity);
      const data = await res.json();
      if (!data.ok) return;

      if (statFlats) statFlats.textContent = new Intl.NumberFormat('ru-RU').format(data.total_flats);
      if (statBuildings) statBuildings.textContent = data.total_buildings;
      if (statPriceFrom) statPriceFrom.textContent = fmtPrice(data.min_price);
      if (heroSub) {
        heroSub.textContent = new Intl.NumberFormat('ru-RU').format(data.total_flats)
          + ' квартир в ' + cityPrep(currentCity) + ' от '
          + fmtPrice(data.min_price) + ' до ' + fmtPrice(data.max_price);
      }
    } catch (e) {
      console.error('stats error:', e);
    }
  }

  // ─── EMPTY/SHOW ───
  // ⛔ 16.10.2026: сервер отдаёт заглушку «Квартиры не найдены» ПУСТОЙ — скрытая
  // надпись лежала в HTML карточек ЖК, и Яндекс брал её в сниппет. Подписи ставятся
  // только в момент показа и снимаются при скрытии. Узлы (и кнопка с её обработчиком)
  // остаются в разметке. Сторож — tests/Unit/Templates/HiddenServiceTextTest.php.
  function fillEmptyText(on) {
    if (!emptyState || typeof emptyState.querySelector !== 'function') return;
    const title = emptyState.querySelector('[data-flats-empty-title]');
    const text = emptyState.querySelector('[data-flats-empty-text]');
    const reset = emptyState.querySelector('[data-flats-empty-reset]');
    if (title) title.textContent = on ? 'Квартиры не найдены' : '';
    if (text) text.textContent = on ? 'Попробуйте изменить параметры поиска' : '';
    if (reset) reset.textContent = on ? 'Сбросить фильтры' : '';
  }
  function showEmpty() {
    grid.innerHTML = '';
    fillEmptyText(true);
    if (emptyState) emptyState.style.display = '';
    if (pagination) pagination.innerHTML = '';
    if (loadMoreWrap) loadMoreWrap.style.display = 'none';
  }
  function hideEmpty() {
    if (emptyState) emptyState.style.display = 'none';
    fillEmptyText(false);
  }

  // ─── JSON-LD ───
  function updateJsonLd(flats) {
    const el = document.getElementById('flatsJsonLd');
    if (!el || !flats) return;

    const items = flats.map((f, i) => ({
      '@type': 'ListItem',
      position: (currentPage - 1) * 24 + i + 1,
      url: location.origin + '/flat.php?id=' + f.id,
    }));

    el.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      // ⛔ F.2-fix: на странице квартир ЖК разметка обязана называть ЖК, а не город.
      // До правки здесь безусловно писалось городское имя, и московская страница
      // уходила в разметку как «Квартиры в новостройках Краснодара» (умолчание).
      name: (PINNED_BUILDING !== '' && String(window.BRONI_FLATS_JK_TITLE || ''))
        || ('Квартиры в новостройках ' + cityGen(currentCity)),
      numberOfItems: totalFlats,
      itemListElement: items,
    });
  }

  // ─── EVENTS ───

  // Переключение города каталога (общая логика для модалки-фильтра). displayName —
  // из модалки (data-city-name), работает для ЛЮБОГО города forSeo (в т.ч. omsk/kaluga,
  // которых нет в cityNamesNom); fallback на карту имён, затем на сам slug.
  function switchCity(slug, displayName) {
    if (!slug || slug === currentCity) return;
    currentLandingScope = '';
    syncLandingNotice();
    currentCity = slug;
    // I4: смена города выходит из режима одного ЖК (building другого города неактуален).
    currentBuilding = '';
    currentSections = ''; // корпус живёт внутри ЖК — вместе с ЖК и уходит
    currentSectionNumbers = '';
    const bSelCity = document.getElementById('filterBuilding');
    if (bSelCity) bSelCity.value = '';
    currentPage = 1;
    geoCall('setCity', slug); // станции прежнего города к новому не относятся
    const name = displayName || cityNom(slug);
    const gen = cityGen(slug);
    const h1 = document.querySelector('.page-hero-title');
    if (h1) h1.innerHTML = 'Квартиры в новостройках<br>' + esc(gen);
    document.title = 'Квартиры в новостройках ' + gen + ' 2026 — БРОНИДОМ';
    // Обновляем подпись кнопки-фильтра + индикатор города в шапке (консистентно).
    const nameEls = document.querySelectorAll('[data-flats-city-name], [data-bd-city-name]');
    nameEls.forEach((el) => { el.textContent = name; });
    const filterBtn = document.getElementById('flatsCityFilter');
    if (filterBtn) filterBtn.setAttribute('data-bd-city', slug);
    loadStats();
    loadFilterOptions();
    loadFlats();
  }

  // City pick через общую модалку шапки (data-city-pick). Владелец 06.07: остаёмся в
  // каталоге квартир и фильтруем на месте, НЕ уходим на /novostroyki/{город}/ (для этого
  // preventDefault на <a href>). Cookie bd_city пишет js/city-modal.js своим делегатом.
  document.addEventListener('click', (e) => {
    const pick = e.target.closest('[data-city-pick]');
    if (!pick) return;
    e.preventDefault();
    if (window.cityModal && window.cityModal.close) window.cityModal.close();
    switchCity(pick.getAttribute('data-city-pick'), pick.getAttribute('data-city-name') || '');
  });

  // Rooms buttons (delegation)
  const roomsBar = document.getElementById('roomsBtns');
  if (roomsBar) roomsBar.addEventListener('click', (e) => {
    const btn = e.target.closest('.room-btn');
    if (!btn) return;
    currentRooms = btn.dataset.rooms;
    currentPage = 1;
    roomsBar.querySelectorAll('.room-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    loadFlats();
  });

  // Sort buttons (delegation)
  const sortBar = document.getElementById('flatsSort');
  if (sortBar) sortBar.addEventListener('click', (e) => {
    const btn = e.target.closest('.sort-btn');
    if (!btn) return;
    currentSort = btn.dataset.sort;
    currentPage = 1;
    sortBar.querySelectorAll('.sort-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    loadFlats();
  });

  // Discount chip (toggle) — «Со скидкой»
  const discountChip = document.getElementById('flatsDiscountChip');
  if (discountChip) discountChip.addEventListener('click', () => {
    currentDiscount = !currentDiscount;
    currentPage = 1;
    discountChip.classList.toggle('active', currentDiscount);
    discountChip.setAttribute('aria-pressed', currentDiscount ? 'true' : 'false');
    hideEmptyOffers(lastOffers); // 8.4: снятый чип с нулём прячется сразу
    loadFlats();
  });

  // 5.3: Installment chip (toggle) — «В рассрочку»
  const installmentChip = document.getElementById('flatsInstallmentChip');
  if (installmentChip) installmentChip.addEventListener('click', () => {
    currentInstallment = !currentInstallment;
    currentPage = 1;
    installmentChip.classList.toggle('active', currentInstallment);
    installmentChip.setAttribute('aria-pressed', currentInstallment ? 'true' : 'false');
    hideEmptyOffers(lastOffers); // 8.4: снятый чип с нулём прячется сразу
    loadFlats();
  });

  // ФИДЫ-2.0 бл.2: Kind chip-group (delegation) — single-select класс помещения
  // «Всё / Квартиры / Апартаменты». Апартаменты юридически не квартиры (нежилое),
  // поэтому покупателю нужна возможность отсечь их — или смотреть только их.
  const kindBar = document.getElementById('kindBtns');
  if (kindBar) kindBar.addEventListener('click', (e) => {
    const btn = e.target.closest('.kind-btn');
    if (!btn) return;
    currentKind = btn.dataset.kind || '';
    currentPage = 1;
    syncKindChips();
    loadFlats();
  });

  // Подсветка активного чипа класса помещения (reset/popstate/restore).
  function syncKindChips() {
    if (!kindBar) return;
    kindBar.querySelectorAll('.kind-btn').forEach(b => {
      const on = (b.dataset.kind || '') === currentKind;
      b.classList.toggle('active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  // 5.2: Renovation chip-group (delegation) — single-select бакет отделки.
  const renovationBar = document.getElementById('renovationBtns');
  if (renovationBar) renovationBar.addEventListener('click', (e) => {
    const btn = e.target.closest('.renovation-btn');
    if (!btn) return;
    currentRenovation = btn.dataset.renovation || '';
    currentPage = 1;
    renovationBar.querySelectorAll('.renovation-btn').forEach(b => {
      const on = b === btn;
      b.classList.toggle('active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    loadFlats();
  });

  // 5.2: подсветка активного чипа отделки по currentRenovation (reset/popstate/restore).
  function syncRenovationChips() {
    document.querySelectorAll('#renovationBtns .renovation-btn').forEach(b => {
      const on = (b.dataset.renovation || '') === currentRenovation;
      b.classList.toggle('active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  // View toggle (delegation)
  const viewBar = document.getElementById('flatsViewToggle');
  if (viewBar) viewBar.addEventListener('click', (e) => {
    const btn = e.target.closest('.view-btn');
    if (!btn) return;
    dropPlansReturn();
    currentView = btn.dataset.view;
    localStorage.setItem('flats_view', currentView);
    viewBar.querySelectorAll('.view-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    // Страницы у видов разные: в «Планировках» их ~3400/24, в «Плитке» — квартиры.
    // Без сброса переход со страницы 40 планировок открывал бы пустой список квартир.
    currentPage = 1;
    loadFlats();
  });

  // Генплан над витриной ЖК (24.09.2026, слово владельца: генплан вместо рендеров,
  // «чтобы было легко искать квартиры»). Клик по корпусу в js/jk-genplan.js шлёт
  // `broni:genplan-corpus`; отбор идёт ТЕМ ЖЕ состоянием `sections`/`section_numbers`,
  // что и ссылка «Квартиры корпуса» из карточки ЖК, — своего пути к выдаче нет.
  // Пустой корпус — отбор снят. Работает только на витрине ОДНОГО дома: в городском
  // списке имя корпуса без ЖК ничего не значит (бэк его там и не применяет).
  document.addEventListener('broni:genplan-corpus', (e) => {
    if (!PINNED_BUILDING) return;
    const detail = (e && e.detail) || {};
    let { section, sectionNumbers: numbers } = window.broniGenplanCorpusFilter(detail);
    // 25.09.2026: строка «1-комнатные» в подсказке генплана выбирает корпус ВМЕСТЕ
    // с комнатностью — чип комнатности переключается тем же состоянием, что и руками.
    let roomsChanged = false;
    if (section && typeof detail.rooms === 'number' && detail.rooms >= 0) {
      const want = String(detail.rooms);
      roomsChanged = want !== currentRooms;
      currentRooms = want;
      document.querySelectorAll('#roomsBtns .room-btn').forEach((b) => {
        b.classList.toggle('active', (b.dataset.rooms || '') === currentRooms);
      });
    }
    // Выбрана комнатность, а в корпусе таких квартир нет (данные — из той же подсказки
    // корпуса): отвечаем генплану «ноль», он пишет «В этом корпусе нет …» и страницу
    // не двигает; прежний отбор корпуса снимаем, чтобы выдача не спорила с подсветкой.
    if (section && currentRooms !== '' && Array.isArray(detail.roomTypes) && detail.roomTypes.length
      && detail.roomTypes.indexOf(Number(currentRooms)) === -1) {
      detail.matched = 0;
      detail.roomsLabel = currentRooms === '0' ? 'студий' : currentRooms + '-комн. квартир';
      section = '';
      numbers = '';
    }
    // 28.09.2026, слово владельца: «любое нажатие на генплане… к списку планировок этого
    // корпуса». Корпус выбран — витрина дома переходит на вкладку «Планировки» (тот же блок,
    // что на карточке ЖК), «Сводка» уходит. Память вида (localStorage) не пишем: это не
    // выбор человека на переключателе, а переход с генплана.
    const toPlans = Boolean(section) && currentView !== 'plans' && Boolean(plansTab());
    if (toPlans) {
      dropPlansReturn();
      currentView = 'plans';
      currentPage = 1;
      syncViewButtons();
    }
    if (section) document.dispatchEvent(new CustomEvent('broni:flats-genplan-plans'));
    if (!toPlans && !roomsChanged && section === currentSections && numbers === currentSectionNumbers) return;
    currentSections = section;
    currentSectionNumbers = numbers;
    currentPage = 1;
    markCorpus(); // загрузка ниже может ждать чужую — кнопка «Сбросить» ждать не должна
    // ⛔ loadFlats() молча выходит, пока идёт прошлая загрузка (`isLoading`): клик по
    // корпусу в первые доли секунды после открытия страницы иначе пропал бы, а
    // выбранный корпус остался бы подсвечен над чужой выдачей. Ждём конца загрузки.
    loadFlatsWhenIdle(50);
  });

  // Apply / Reset
  const applyBtn = document.getElementById('flatsApply');
  if (applyBtn) applyBtn.addEventListener('click', () => { currentPage = 1; loadFlats(); });

  // «Метро и районы» (27.09.2026): «Показать N ЖК» в окне js/flats-geo.js. Выдача — во
  // всех видах (сводка берёт тот же запрос, планировки — тот же action=list с view=plans).
  // Ответ на прежний выбор не нужен: прерываем его и грузим новый, как у «Сбросить».
  document.addEventListener('broni:flats-geo-change', () => {
    currentPage = 1;
    if (isLoading && abortCtrl) abortCtrl.abort();
    loadFlatsWhenIdle(50);
  });

  const resetBtn = document.getElementById('flatsReset');
  const resetEmptyBtn = document.getElementById('flatsResetEmpty');
  function resetFilters() {
    currentLandingScope = '';
    syncLandingNotice();
    currentRooms = '';
    // ⛔ 25.09.2026: СБРОС СНИМАЕТ ФИЛЬТРЫ, А НЕ СТРАНИЦУ. На витрине ОДНОГО ЖК дом —
    // не фильтр, его назвал адрес: прежнее `currentBuilding = ''` уводило выдачу на весь
    // город под заголовком ЖК (прод 25.09, «ЖК РИДЗ»: 339 → «Найдено 14449»). Возврат
    // дома СЛЕДОМ (js/flats-mobile-filter.js, событием через 0 и 900 мс) не работал:
    // loadFlats() молча выходит, пока идёт запрос самого сброса, — и уходил один запрос,
    // без building_id. Поэтому дом держит сам сброс. Городская витрина: PINNED_BUILDING
    // пуст — сброс по-прежнему даёт весь город. Проба — tests/JS/flats-reset-keeps-jk.test.js.
    currentBuilding = PINNED_BUILDING;
    currentSections = ''; // jk-smart-filter 1.3
    currentSectionNumbers = '';
    currentDiscount = false;
    currentRenovation = '';
    currentInstallment = false; // 5.3
    currentKind = ''; // ФИДЫ-2.0 бл.2: сброс к «Всё»
    currentPage = 1;
    geoCall('reset'); // «Метро и районы» — вместе со всеми (27.09.2026)
    if (discountChip) {
      discountChip.classList.remove('active');
      discountChip.setAttribute('aria-pressed', 'false');
    }
    if (installmentChip) {
      installmentChip.classList.remove('active');
      installmentChip.setAttribute('aria-pressed', 'false');
    }
    syncRenovationChips();
    syncKindChips();
    document.querySelectorAll('#roomsBtns .room-btn').forEach(b => b.classList.toggle('active', b.dataset.rooms === ''));
    ['priceMin','priceMax','areaMin','areaMax','floorMin','floorMax'].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.value = '';
    });
    // Пикер ЖК — СЕЙЧАС, а не ответом фасетов. ⛔ Это не дубль loadFilterOptions():
    // та ставит пикер лишь после ответа и при пустом доме ОСТАВЛЯЕТ прежний выбор
    // (`currentBuilding || bSel.value`), а collectFilters() читает пикер запасным
    // источником ещё до ответа. Без этой строки сброс на витрине ГОРОДА ушёл бы с
    // выбранным ранее ЖК (проба «витрина города» в tests/JS/flats-reset-keeps-jk.test.js).
    // Значение — дом запроса: на витрине ЖК её дом, на городской — «Все ЖК».
    const buildingPicker = document.getElementById('filterBuilding');
    if (buildingPicker) buildingPicker.value = currentBuilding;
    const deadlineSelect = document.getElementById('filterDeadline');
    if (deadlineSelect) deadlineSelect.value = '';
    loadFilterOptions(); // 6.1d fix: сброс ЖК → фасеты «Отделка» обратно по городу (на витрине ЖК — по ЖК)
    // ⛔ ГОНКА «1к» → СРАЗУ «Сбросить» (проверка 25.09, P2-1). Пока идёт запрос «1к»,
    // голый loadFlats() молча выходил: запрос сброса не уходил, на экране оставалось
    // 339 при фильтре «Все» и скрытой кнопке. Ответ на отменённое состояние не нужен —
    // прерываем его и грузим сброс, как только прошлая загрузка отпустит.
    if (isLoading && abortCtrl) abortCtrl.abort();
    loadFlatsWhenIdle(50);
    // Корпус, выбранный на генплане, сброшен вместе со всеми — генплан снимает подсветку.
    document.dispatchEvent(new CustomEvent('broni:flats-filters-reset'));
  }
  if (resetBtn) resetBtn.addEventListener('click', resetFilters);
  if (resetEmptyBtn) resetEmptyBtn.addEventListener('click', resetFilters);

  // Pagination click
  if (pagination) pagination.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-page]');
    if (!btn) return;
    // Блок 7.1: ряд теперь из ссылок — переход по href отменяем, листаем без
    // перезагрузки, как и раньше. Клик с Ctrl/Cmd/Shift (новая вкладка) не трогаем.
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    currentPage = parseInt(btn.dataset.page, 10);
    window.scrollTo({ top: grid.offsetTop - 100, behavior: 'smooth' });
    loadFlats();
  });

  // "Показать ещё" (мобильный)
  if (loadMoreBtn) loadMoreBtn.addEventListener('click', () => {
    currentPage++;
    loadFlats(true);
  });

  // popstate (кнопка «Назад»)
  window.addEventListener('popstate', () => {
    const params = new URLSearchParams(location.search);
    currentLandingScope = params.get('landing_scope') || '';
    syncLandingNotice();
    // ⛔ 14.08.2026: тот же фолбэк, что при загрузке (строка 21). Без него «Назад» на
    // ЧПУ городской витрины сбрасывал бы город в Краснодар, оставив адрес московским.
    // 18.09.2026: + город от сервера — на ЧПУ ЖК город в query больше не пишется.
    currentCity = params.get('city') || PINNED_CITY || SERVER_CITY || 'krasnodar';
    currentRooms = params.get('rooms') || '';
    if (params.get('from_slice') === '1' && params.get('rooms_min') === '4') currentRooms = '4';
    // F.1: тот же фолбэк, что при загрузке. Без него «Назад» на ЧПУ-адресе
    // расширял бы выдачу до всего города, оставив адрес прежним.
    currentBuilding = params.get('building_id') || PINNED_BUILDING;
    currentSort = params.get('sort') || DEFAULT_SORT;
    currentDiscount = params.get('discount') === '1';
    currentRenovation = params.get('renovation') || '';
    currentInstallment = params.get('installment') === '1'; // 5.3
    currentKind = params.get('kind') || ''; // ФИДЫ-2.0 бл.2
    currentSections = params.get('sections') || ''; // jk-smart-filter 1.3
    currentSectionNumbers = params.get('section_numbers') || '';
    currentPage = Math.max(1, parseInt(params.get('page'), 10) || 1);
    // Кнопка «Назад» обязана возвращать и ВИД, иначе уход из планировок в плитку
    // необратим: адрес меняется, а на экране остаётся прежняя выдача.
    currentView = params.get('view') === 'plans' ? 'plans' : (localStorage.getItem('flats_view') || 'grid');
    syncViewButtons();
    if (discountChip) {
      discountChip.classList.toggle('active', currentDiscount);
      discountChip.setAttribute('aria-pressed', currentDiscount ? 'true' : 'false');
    }
    if (installmentChip) {
      installmentChip.classList.toggle('active', currentInstallment);
      installmentChip.setAttribute('aria-pressed', currentInstallment ? 'true' : 'false');
    }
    syncRenovationChips();
    syncKindChips(); // ФИДЫ-2.0 бл.2: класс помещения тоже восстанавливаем из URL
    // Комнатность, диапазоны и срок сдачи — из ТОГО ЖЕ адреса (проверка 25.09, P2-2):
    // иначе «Назад» в `?rooms=1` показывал 339 квартир под подсвеченным «Все», а
    // «Сбросить» (её видимость читается по чипам и полям) стояла скрытой.
    document.querySelectorAll('#roomsBtns .room-btn')
      .forEach(b => b.classList.toggle('active', (b.dataset.rooms || '') === currentRooms));
    ['price_min:priceMin','price_max:priceMax','area_min:areaMin','area_max:areaMax','floor_min:floorMin','floor_max:floorMax'].forEach(pair => {
      const [key, id] = pair.split(':');
      const el = document.getElementById(id);
      if (el) el.value = params.get(key) || '';
    });
    const deadlineBack = document.getElementById('filterDeadline');
    if (deadlineBack) deadlineBack.value = params.get('deadline') || '';
    geoCall('setCity', currentCity);
    geoCall('readUrl'); // «Метро и районы» — из того же адреса (27.09.2026)
    loadFilterOptions(); // 6.1d fix: область могла смениться (building_id из URL) → пересчёт фасетов
    loadFlats();
  });

  // Debounce на range inputs (300ms)
  let debounceTimer = null;
  ['priceMin','priceMax','areaMin','areaMax','floorMin','floorMax'].forEach(id => {
    const el = document.getElementById(id);
    if (el) el.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => { currentPage = 1; loadFlats(); }, 300);
    });
  });

  // Restore view toggle on load
  function syncViewButtons() {
    document.querySelectorAll('#flatsViewToggle .view-btn').forEach(b => {
      b.classList.toggle('active', b.dataset.view === currentView);
    });
  }
  syncViewButtons();

  // Restore URL params on load
  function restoreFromUrl() {
    const params = new URLSearchParams(location.search);
    // Вид из адреса важнее сохранённого в localStorage: человек открыл ИМЕННО эту
    // ссылку. Иначе присланная ссылка на планировки открывалась бы плиткой, если у
    // получателя в прошлый раз стояла она.
    if (params.get('view') === 'plans') {
      currentView = 'plans';
      syncViewButtons();
    }
    const rooms = params.get('rooms');
    if (rooms !== null) {
      currentRooms = rooms;
      document.querySelectorAll('#roomsBtns .room-btn').forEach(b => b.classList.toggle('active', b.dataset.rooms === rooms));
    }
    const sort = params.get('sort');
    if (sort) {
      currentSort = sort;
      document.querySelectorAll('#flatsSort .sort-btn').forEach(b => b.classList.toggle('active', b.dataset.sort === sort));
    }
    if (params.get('discount') === '1') {
      currentDiscount = true;
      if (discountChip) {
        discountChip.classList.add('active');
        discountChip.setAttribute('aria-pressed', 'true');
      }
    }
    const reno = params.get('renovation');
    if (reno) {
      currentRenovation = reno;
      syncRenovationChips();
    }
    ['price_min:priceMin','price_max:priceMax','area_min:areaMin','area_max:areaMax','floor_min:floorMin','floor_max:floorMax'].forEach(pair => {
      const [key, id] = pair.split(':');
      const val = params.get(key);
      if (val) {
        const el = document.getElementById(id);
        if (el) el.value = val;
      }
    });
    const bid = params.get('building_id');
    if (bid) {
      const el = document.getElementById('filterBuilding');
      if (el) el.value = bid;
    }
    // jk-smart-filter 1.3: ?sections= из ссылки «Открыть в полном каталоге →».
    // Контрола в DOM у корпусов нет — состояние восстанавливаем и дальше несём
    // в запросы (collectFilters) и в URL (syncUrl), чтобы «Назад»/перезагрузка
    // не теряли выбранный на карточке ЖК срок сдачи.
    const sections = params.get('sections');
    if (sections) currentSections = sections;
    currentSectionNumbers = params.get('section_numbers') || '';
    // 6.1i: URL-параметр developer удалён вместе с фильтром «Застройщик».
    const dl = params.get('deadline');
    if (dl) {
      const el = document.getElementById('filterDeadline');
      if (el) el.value = dl;
    }
  }

  // ─── КЛИК ПО КАРТОЧКЕ = ПРЯМОЙ ПЕРЕХОД НА СТРАНИЦУ КВАРТИРЫ (U.1, команда владельца) ───
  // Карточка — настоящая <a href="/flat.php?id=N">, и делегата-перехватчика здесь
  // БОЛЬШЕ НЕТ. Раньше клик глушился preventDefault и вместо перехода выезжал
  // оверлей справа (window.openFlatOverlay). Владелец 02.08 попросил обратное:
  // клик по квартире открывает её страницу.
  //
  // Что это даёт помимо самого перехода: работают средняя кнопка мыши, Ctrl/Cmd+клик,
  // «Открыть в новой вкладке» из контекстного меню и перетаскивание ссылки — то есть
  // ровно то, что даёт браузер обычной ссылке и что перехватчик отбирал.
  //
  // ⚠️ Клик по плашке галереи по-прежнему НЕ переход: свой делегат ниже гасит его
  // сам (preventDefault + stopImmediatePropagation) — он не полагался на этот
  // перехватчик. Оверлей `flat-overlay.js` остаётся дверью карточки ЖК (jk.php,
  // флаг BRONI_FLAT_OVERLAY_INLINE) — там поведение НЕ менялось.

  // ─── HIDDEN FLATS: фильтр скрытых ───
  const HIDE_KEY = 'bronidom_flat_hidden';
  function getHidden() { try { return JSON.parse(localStorage.getItem(HIDE_KEY)) || []; } catch { return []; } }

  const _origAppendCards = appendCards;
  appendCards = function(flats) {
    const hidden = getHidden();
    const filtered = hidden.length > 0 ? flats.filter(f => !hidden.includes(f.id)) : flats;
    _origAppendCards(filtered);
  };

  // ─── ГАЛЕРЕЯ-ПЛАШКИ (референс «МОД») ───
  // Наведение (desktop) / тап (mobile) по плашке → её фото (opacity-свап). Увели мышь с
  // фото → возврат к первому (план). Наведение на САМО фото НЕ листает — только плашки.
  // Клик по плашке НЕ переходит на квартиру (preventDefault + stopImmediatePropagation).
  function galleryShow(gallery, idx) {
    const imgs = gallery.querySelectorAll('.flat-card-image');
    const n = imgs.length;
    if (n <= 1) return;
    idx = idx < 0 ? 0 : (idx >= n ? n - 1 : idx);
    if ((parseInt(gallery.dataset.idx, 10) || 0) === idx) return; // свап только при смене плашки
    gallery.dataset.idx = idx;
    imgs.forEach((im, i) => im.classList.toggle('active', i === idx));
    const pills = gallery.parentElement.querySelectorAll('.flat-card-gal-pill');
    pills.forEach((p, i) => p.classList.toggle('active', i === idx));
  }
  function pillGallery(pill) {
    const wrap = pill.closest('.flat-card-img-wrap');
    return wrap && wrap.querySelector('[data-gallery]');
  }

  // Делегирование на grid (не листенер на каждую карточку). mouseover — bubbling-аналог
  // mouseenter, срабатывает на плашке под курсором.
  grid.addEventListener('mouseover', (e) => {
    const pill = e.target.closest('.flat-card-gal-pill');
    if (!pill) return;
    const gallery = pillGallery(pill);
    if (gallery) galleryShow(gallery, parseInt(pill.dataset.galPill, 10) || 0);
  });
  grid.addEventListener('mouseout', (e) => {
    const wrap = e.target.closest('.flat-card-img-wrap');
    if (!wrap || (e.relatedTarget && wrap.contains(e.relatedTarget))) return;
    const gallery = wrap.querySelector('[data-gallery]');
    if (gallery) galleryShow(gallery, 0); // ушли с фото → вернуть план
  });
  // Клик/тап по плашке: переключить фото, НЕ переходить на квартиру. Плашка лежит ВНУТРИ
  // ссылки-карточки, поэтому переход гасит preventDefault (U.1: делегата-оверлея, на
  // который ссылался прежний комментарий, больше нет — плашка защищает себя сама).
  grid.addEventListener('click', (e) => {
    const pill = e.target.closest('.flat-card-gal-pill');
    if (!pill) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const gallery = pillGallery(pill);
    if (gallery) galleryShow(gallery, parseInt(pill.dataset.galPill, 10) || 0);
  });

  // ─── FILTER OPTIONS (ЖК) ─── (6.1i: селект «Застройщик» удалён)
  async function loadFilterOptions() {
    try {
      // 6.1d fix: в building-view скоупим фасеты «Отделка» к выбранному ЖК —
      // чипы показывают реальные бакеты этого ЖК, а не города (иначе клик по
      // «городскому» чипу, которого в ЖК нет, давал пустой каталог).
      const bidParam = currentBuilding ? '&building_id=' + encodeURIComponent(currentBuilding) : '';
      const optionScope = currentLandingScope;
      const scopeParam = optionScope ? '&landing_scope=' + encodeURIComponent(optionScope) : '';
      const res = await fetch(API + '?action=filter_options&city=' + currentCity + bidParam + scopeParam);
      const data = await res.json();
      if (!data.ok || optionScope !== currentLandingScope) return;

      // «Метро и районы» (27.09.2026): числа окна — только ЖК, где сейчас продаются
      // квартиры. Список ЖК города — тот же ответ, что наполняет пикер «ЖК».
      if (!currentBuilding) {
        try {
          document.dispatchEvent(new CustomEvent('broni:flats-options', {
            detail: { city: currentCity, landingScope: optionScope,
              buildings: Array.isArray(data.buildings) ? data.buildings : [] },
          }));
        } catch {
          // сообщать некому — числа окна посчитаются по всем ЖК города
        }
      }

      // 6.1k: пикер «ЖК» с фото — <project-picker>. Наполняем id/name/image_url/
      // flat_count; выбор фильтрует каталог тем же building_id (host владеет
      // state/URL/restore/reset, компонент — чистый UI, эмитит project-change).
      const bSel = document.getElementById('filterBuilding');

      if (bSel) {
        const prev = currentBuilding || bSel.value;
        if (typeof bSel.setProjects === 'function') {
          bSel.setProjects(data.buildings || []);
        }
        bSel.value = prev || '';
        if (!bSel._bronidomBound) {
          // jk-smart-filter 1.3: корпуса прежнего ЖК («Литер 1») в новом не
          // существуют — при смене проекта фильтр корпусов обнуляем.
          bSel.addEventListener('project-change', () => {
            currentBuilding = bSel.value;
            currentSections = '';
            currentSectionNumbers = '';
            currentPage = 1;
            loadFilterOptions(); // 6.1d fix: пересчитать фасеты «Отделка» под область (ЖК ⇄ город)
            loadFlats();
          });
          bSel._bronidomBound = true;
        }
      }

      // Счётчики комнатности (2026-07-29): «2к · 47». Чип без квартир гасим —
      // клик по нему давал бы пустую выдачу, и это читается как поломка сайта.
      const roomCounts = {};
      (data.rooms || []).forEach(r => { roomCounts[String(r.key)] = r.count; });
      document.querySelectorAll('#roomsBtns .room-btn').forEach(btn => {
        const key = btn.dataset.rooms || '';
        const cntEl = btn.querySelector('.room-btn-cnt');
        if (key === '') return; // «Все» — без счётчика
        // 4к+ агрегирует всё от четырёх комнат: фильтр по этому чипу тоже rooms_min.
        const n = key === '4'
          ? Object.keys(roomCounts).reduce((s, k) => Number(k) >= 4 ? s + roomCounts[k] : s, 0)
          : (roomCounts[key] || 0);
        if (cntEl) cntEl.textContent = n ? String(n) : '';
        btn.classList.toggle('room-btn--empty', !n);
      });

      // Границы слайдеров — по живым данным города (или выбранного ЖК).
      SLIDERS.forEach(cfg => setupSlider(cfg, (data.ranges || {})[cfg.key]));

      // 5.2: чипы «Отделка» — показываем только присутствующие в городе бакеты + счётчики
      // (N5: бэк уже считает только available). Порядок бакетов задан бэком (RenovationBucket::ORDER).
      const renoBar = document.getElementById('renovationBtns');
      if (renoBar) {
        const counts = {};
        (data.renovation || []).forEach(r => { counts[r.key] = r.count; });
        renoBar.querySelectorAll('.renovation-btn[data-renovation]').forEach(btn => {
          const key = btn.dataset.renovation;
          if (key === '') return; // «Любая» всегда видима
          const cntEl = btn.querySelector('.renovation-btn-cnt');
          if (counts[key]) {
            btn.hidden = false;
            if (cntEl) cntEl.textContent = ' ' + counts[key];
          } else {
            btn.hidden = true;
            if (cntEl) cntEl.textContent = '';
          }
        });
        // Если активный бакет исчез в новом городе — сбрасываем на «Любая».
        if (currentRenovation && !counts[currentRenovation]) {
          currentRenovation = '';
        }
        syncRenovationChips();
      }

      hideEmptyOffers(data.offers);
    } catch (e) {
      console.error('filter_options error:', e);
    }
  }

  // Блок 8.4 «ФИД ЯНДЕКСА» (24.09.2026): правило одно на все витрины — вариант «Срок
  // сдачи» и чипы «Со скидкой» / «В рассрочку», за которыми 0 квартир, не показываются;
  // выбранный виден всегда, чтобы его можно было снять. Числа считает сервер тем же
  // условием, что и отбор (FlatHandler::offersFacet). Нет счётчиков (старый ответ из
  // кэша) — прятать нечего: всё видно, как до блока.
  function hideEmptyOffers(offers) {
    if (!offers || typeof offers !== 'object') return;
    lastOffers = offers;
    const dlCounts = {};
    (offers.deadline || []).forEach(d => { dlCounts[String(d.key)] = d.count; });
    const sel = document.getElementById('filterDeadline');
    if (sel && offers.deadline) {
      Array.prototype.forEach.call(sel.options, opt => {
        if (!opt.value) return;
        const empty = !dlCounts[opt.value] && opt.value !== sel.value;
        // hidden прячет строку в списке, disabled — там, где браузер строки не прячет (iOS).
        opt.hidden = empty;
        opt.disabled = empty;
      });
    }
    [['flatsDiscountChip', 'discount', currentDiscount], ['flatsInstallmentChip', 'installment', currentInstallment]]
      .forEach(([id, key, active]) => {
        const chip = document.getElementById(id);
        if (!chip || typeof offers[key] !== 'number') return;
        chip.classList.toggle('hidden', !offers[key] && !active);
      });
    // Оба чипа спрятаны — не оставлять пустую подпись «Предложения» (группа из flats-showcase).
    const d = document.getElementById('flatsDiscountChip');
    const grp = d && d.closest('.flats-filter-group');
    if (grp) {
      const chips = grp.querySelectorAll('.flats-discount-chip, .flats-installment-chip');
      grp.classList.toggle('hidden', chips.length > 0 && Array.prototype.every.call(chips, c => c.classList.contains('hidden')));
    }
  }

  // ─── STICKY-ГОРОД (2026-07-14) ───
  // Если URL БЕЗ ?city — префилл каталога выбранным городом из cookie bd_city.
  // ⛔ Анти-клоакинг: сервер НЕ меняет $city/canonical/title по cookie; смена —
  // ТОЛЬКО клиентски здесь. Slug берём из индикатора шапки (.header-city[data-bd-city]
  // = CurrentCity::resolve() на сервере, т.е. cookie). Бот без cookie → krasnodar,
  // canonical/title дефолтные. Явный ?city в URL имеет приоритет (не трогаем).
  function applyStickyCityPrefill() {
    // ⛔ F.1-fix (13.08.2026): страница КВАРТИР ЖК липким городом не управляется.
    // Здесь нет `?city` в адресе, поэтому прежний ранний выход не срабатывал, и
    // функция шла дальше: обнуляла currentBuilding (стирая PINNED_BUILDING),
    // переписывала заголовок и H1 на городские и уводила адрес на каталог города.
    // Живая проверка прода: /novostroyki/moscow/zhk-city-bay/kvartiry/ через ~200 мс
    // превращался в /flats.php?city=moscow — сервер печатал лицо ЖК, а клиент
    // возвращал чужое. Яндекс исполняет JS, то есть видел именно подмену.
    // Дом закреплён сервером ⇒ страница про ЖК, а не про город. Выходим.
    if (PINNED_BUILDING !== '') return;
    // ⛔ 14.08.2026: ЧПУ городской витрины липким городом тоже не управляется. В её
    // адресе нет `?city=`, поэтому проверка ниже не срабатывает, и функция шла бы
    // дальше: москвич с cookie `bd_city=krasnodar` получил бы под адресом Москвы
    // краснодарскую выдачу, переписанный H1 и `<title>`. Город назван АДРЕСОМ —
    // это сильнее личного предпочтения (и это же читает canonical на сервере).
    if (PINNED_CITY !== '') return;
    if (new URLSearchParams(location.search).get('city')) return;
    const chip = document.querySelector('.header-city[data-bd-city]');
    const slug = chip ? (chip.getAttribute('data-bd-city') || '') : '';
    if (!slug || !/^[a-z]{2,15}$/.test(slug) || slug === currentCity) return;
    currentCity = slug; // до первого loadFlats — без лишнего запроса
    geoCall('setCity', slug);
    currentBuilding = '';
    currentSections = ''; // корпус живёт внутри ЖК — вместе с ЖК и уходит
    currentSectionNumbers = '';
    const name = cityNom(slug);
    const gen = cityGen(slug);
    const h1 = document.querySelector('.page-hero-title');
    if (h1) h1.innerHTML = 'Квартиры в новостройках<br>' + esc(gen);
    document.title = 'Квартиры в новостройках ' + gen + ' 2026 — БРОНИДОМ';
    document.querySelectorAll('[data-flats-city-name]').forEach((el) => { el.textContent = name; });
    const filterBtn = document.getElementById('flatsCityFilter');
    if (filterBtn) filterBtn.setAttribute('data-bd-city', slug);
  }

  // ─── «СРАЗУ К КВАРТИРАМ» (слово владельца 28.09.2026) ───
  // Ссылка с якорем `#planirovki` (строка комнатности корпуса на генплане — js/jk-genplan.js)
  // или `#rooms=N` («Все N квартир — в витрине ЖК» со страницы комнатности) открывает витрину на полосе «Найдено N квартир» над выдачей, а не на генплане сверху.
  // Прямой заход без якоря (из поиска) — сверху, как был. Якорь снимается сразу: «Назад»
  // с квартиры и обновление страницы не должны снова дёргать человека вниз.
  function landOnResults() {
    if (!LAND_ON_RESULTS) return;
    if (location.hash) {
      try { history.replaceState(history.state, '', location.pathname + location.search); } catch (e) { /* без History API якорь остаётся */ }
    }
    const bar = document.querySelector('.flats-toolbar-section');
    if (!bar || typeof window.scrollTo !== 'function') return;
    requestAnimationFrame(() => {
      const top = bar.getBoundingClientRect().top + window.scrollY - 12;
      window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: 'instant' });
    });
  }

  // ─── INIT ───
  restoreFromUrl();
  // Якорь `#planirovki` (строка «Студии · от … ₽» генплана страницы квартиры, 28.09.2026):
  // человек просил планировки этой комнатности — витрина дома открывается вкладкой
  // «Планировки». Память вида не пишем; `#rooms=N` («все квартиры») вид не трогает.
  if (/^#planirovki(?:&.*)?$/.test(String(location.hash || '')) && plansTab()) {
    currentView = 'plans';
    syncViewButtons();
  }
  applyStickyCityPrefill();
  loadStats();
  loadFilterOptions();
  Promise.resolve(loadFlats()).then(landOnResults, landOnResults);
})();
